import { __, __string, addIntlData } from 'first-intl';
import { DownloadService, Config } from '@hugendubel/react-ws';
import { Track, TRACK_ID } from '@hugendubel/tracking_client';
import { EnumUtil, Type, createCustomerCall, Method, WsPageableList, WsParser, Money, WsErrorCode, WsAvailabilityData } from '@hugendubel/ws_client';
import { DateUtil, DiscountUtil, UrlUtil, _ } from '@hugendubel/utils';
import { ClientNavigation, Toaster, Shortened, Img, LinkUtil, Button, A, CSSBreakPoint, useCarouselAmount, Carousel, Modal, useProgressCallback, DateTag, Select, useSafeState, Pager, TrackingForm, useCurrentQuery, FormInput, AreaSpinner, IconTeaser, Slider, useToggle, calculateRatingFromPercent, ReviewStars, useArticleDetailsLink } from '@hugendubel/react-basic';
import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react';
import { BasketService, Cart } from '@hugendubel/cart';
import { Track as Track$1 } from '@hugendubel/tracking_manager';
import { useLocation, useNavigate } from 'react-router-dom';

var language = "Sprache: ";
var intlData = {
	"article.addToBasket.button.back": "Weiter stöbern",
	"article.addToBasket.button.forward": "Zum Warenkorb",
	"article.addToBasket.error": "Beim Hinzufügen des Artikels in den Warenkorb ist ein Fehler aufgetreten.",
	"article.addToBasket.heading": "Vielen Dank",
	"article.addToBasket.heading.sub.multi": "Alle {count} Artikel wurden in Ihren Warenkorb gelegt.",
	"article.addToBasket.heading.sub.single": "Der Artikel wurde in Ihren Warenkorb gelegt.",
	"article.addToBasket.multi.recommendationHeading": "Kunden, die diese Artikel gekauft haben, kauften auch",
	"article.addToBasket.no.article.error": "Leider konnte der Artikel nicht zu ihrem Warenkorb gelegt werden",
	"article.addToBasket.single.recommendationHeading": "Kunden, die diesen Artikel gekauft haben, kauften auch",
	"article.delivery": "Zustellung: ",
	"article.filter.label": "nach Artikel-Typ filtern",
	"article.ock.button": "Sofort kaufen",
	"article.sort.label": "Artikel sortieren",
	"searchArticle.btn.add.to.cart": "In den Warenkorb",
	"searchArticle.btn.pre.order": "Jetzt vorbestellen",
	"searchArticle.formats.info": "{formatCount} weitere Formate",
	"searchArticle.formats.info.single": "{formatCount} weiteres Format",
	"searchArticle.details.discount.defective.info": "als {productTypeDisplayName}",
	"searchArticle.publicationDate.label": " - erscheint am: ",
	"searchArticle.publicationDate.label.empty": " ",
	"searchArticle.ratings.label.single": "Bewertung",
	"searchArticle.ratings.label.multi": "Bewertungen",
	"audioBooks.button.webreader": "zu meinen Hörbuch Downloads im Webreader",
	"audioBooks.empty": "Sie haben noch keine Hörbuch Downloads erworben.",
	"audioBooks.heading": "Meine Hörbuch Downloads",
	"audioBooks.help.context.topic": " – Hörbücher",
	"audioBooks.help.downloads": "Alle Hörbuch Downloads stehen Ihnen auch als Download zur Verfügung.",
	"audioBooks.help.transfer": "Alle Infos zum Übertragen von Hörbuch Downloads auf Endgeräte finden Sie",
	"audioBooks.help.transfer.linkText": "Zur Hilfe-Seite",
	"audioBooks.intro": "Sie finden alle Ihre Hörbuch Downloads hier im komfortablen tolino Webreader:",
	"authors.from": "von",
	"button.addToCart": "In den Warenkorb",
	"button.download": "Download",
	"button.listen": "Jetzt hören",
	"button.preorder": "Jetzt vorbestellen",
	"button.read": "Jetzt lesen",
	"button.search": "Suchen",
	"digital-articles.adobeId.link": "Zur Einrichtung der Adobe ID",
	"digital-articles.ekidzApp": "Hier finden Sie die zugehörige App in Ihrem Appstore/Google Play Store:",
	"digital-articles.ekidzApp.android": "Ekidz-App im Google Play Store (Android)",
	"digital-articles.ekidzApp.iOS": "Ekidz-App im App Store(iOS)",
	"digital-articles.filter.search": "Titel, Autor",
	"digital-articles.notReady": "Dieser Artikel ist noch nicht freigegeben. Bitte versuchen Sie es später noch einmal.",
	"digital-articles.orderDate": "Bestelldatum:",
	"digital-articles.orderNumber": "Bestellnummer:",
	"digital-articles.search.noResults": "Sie haben keine Artikel zu diesem Suchbegriff.",
	"digital-articles.sort.author.asc": "Autor A-Z",
	"digital-articles.sort.author.desc": "Autor Z-A",
	"digital-articles.sort.date.asc": "Kaufdatum ↑",
	"digital-articles.sort.date.desc": "Kaufdatum ↓",
	"digital-articles.sort.title.asc": "Titel A-Z",
	"digital-articles.sort.title.desc": "Titel Z-A",
	"digital-articles.tolinoApp": "Gratis: Unsere {tolinoAppName} für Tablets & Smartphones",
	"digital-articles.tolinoApp.android": "Tolino-App im Google Play Store (Android)",
	"digital-articles.tolinoApp.iOS": "Tolino-App im App Store(iOS)",
	"digital-articles.tolinoApp.name": "tolino App",
	"eBooks.abo": "Die eBooks aus Ihren Abos finden Sie in der",
	"eBooks.abo.link": "„Abo-Verwaltung“",
	"eBooks.button.webreader": "zu meinen eBooks im Webreader",
	"eBooks.empty": "Sie haben noch keine eBooks erworben.",
	"eBooks.heading": "Meine eBooks",
	"eBooks.help.adobeId": "Alle eBooks stehen Ihnen auch als Download zur Verfügung. Für kopiergeschützte eBooks ist eine Adobe ID nötig.",
	"eBooks.help.context.topic": " – eBooks",
	"eBooks.help.transfer": "Alle Infos zum Übertragen von eBooks auf Endgeräte finden Sie auf unserer Hilfe-Seite.",
	"eBooks.help.transfer.linkText": "Zur Hilfe-Seite",
	"eBooks.intro": "Sie finden alle Ihre eBooks hier im komfortablen tolino Webreader:",
	"error.general": "Leider ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
	"help.context.headline": "Häufig gestellte Fragen {topic}",
	language: language,
	"language.abkhaz": "Abkhaz",
	"language.afrihili": "Afrihili",
	"language.afrikaans": "Afrikaans",
	"language.albanian": "Albanisch",
	"language.aleut": "Aleutisch",
	"language.algonkin": "algonkin",
	"language.amharic": "Amharisch",
	"language.apache": "Apache",
	"language.arabic": "Arabisch",
	"language.aramaic": "Aramäisch",
	"language.armenian": "Armenisch",
	"language.azerbaijani": "Azerbaijani",
	"language.bantu": "Bantu",
	"language.basque": "Baskisch",
	"language.belarusian": "Weißrussisch",
	"language.bengali": "Bengalisch",
	"language.bosnian": "Bosnisch",
	"language.braille": "Braille",
	"language.bulgarian": "Bulgarisch",
	"language.burmese": "Burmesisch",
	"language.catalan": "Katalanisch",
	"language.cebuano": "Cebuano",
	"language.coptic": "Koptisch",
	"language.creole": "Creolisch",
	"language.czech": "Tschechisch",
	"language.dakota": "Dakota",
	"language.danish": "Dänisch",
	"language.dravidian": "Dravidisch",
	"language.dutch": "Niederländisch",
	"language.egypt": "Ägyptisch",
	"language.elamite": "Elamisch",
	"language.english": "Englisch",
	"language.eskaleut": "Eskimo-aleutisch",
	"language.esperanto": "Esperanto",
	"language.estonian": "Estnisch",
	"language.ethiopian": "Äthiopisch",
	"language.farsi": "Farsi",
	"language.filipino": "Filipino",
	"language.finnish": "Finnisch",
	"language.french": "Französisch",
	"language.georgian": "Georgisch",
	"language.greek": "Griechisch",
	"language.gujarati": "Gujarati",
	"language.hausa": "Hausa",
	"language.hawaiian": "Hawaiianisch",
	"language.hebrew": "Hebräisch",
	"language.hiligaynon": "Hiligaynon",
	"language.hindi": "Hindi",
	"language.hungarian": "Ungarisch",
	"language.icelandic": "Isländisch",
	"language.igbo": "Igbo",
	"language.indonesian": "Indonesisch",
	"language.inupiaq": "Inupiaq",
	"language.irish": "Irisch",
	"language.iroquoian": "Irokesisch",
	"language.italian": "Italienisch",
	"language.japanese": "Japanisch",
	"language.kashmiri": "Kashmiri",
	"language.khmer": "Khmer",
	"language.kinyarwanda": "Kinyarwanda",
	"language.kiswahili": "Swahili",
	"language.klingon": "Klingonisch",
	"language.korean": "Koreanisch",
	"language.kurdish": "Kurdisch",
	"language.lao": "Laotisch",
	"language.latin": "Lateinisch",
	"language.latvian": "Lettisch",
	"language.lithuanian": "Lithauisch",
	"language.low_german": "Plattdeutsch",
	"language.luxembourgish": "Luxenburgisch",
	"language.makassaric": "Makassarisch",
	"language.malay": "Malaiisch",
	"language.malayalam": "Malayalam",
	"language.mandarin": "Mandarin",
	"language.marathi": "Marathi",
	"language.mongolian": "Mongolisch",
	"language.multi": "Mehrsprachig",
	"language.navajo": "Navajo",
	"language.norwegian": "Norwegisch",
	"language.nyankole": "Nyankole",
	"language.old_english": "Altenglisch",
	"language.old_french": "Altfranzösisch",
	"language.old_greek": "Altgriechisch",
	"language.persian": "Persisch",
	"language.polish": "Polnisch",
	"language.portuguese": "Portugiesisch",
	"language.punjabi": "Punjabi",
	"language.romanian": "Rumänisch",
	"language.sanskrit": "Sanskrit",
	"language.sao": "Sao",
	"language.sardinian": "Sardisch",
	"language.scotch": "Schottisch",
	"language.scottish gaelic": "Gälisch",
	"language.semitic": "Semitisch",
	"language.serbian": "Serbisch",
	"language.slovak": "Slovakisch",
	"language.slovene": "Slowenisch",
	"language.somalian": "Somalisch",
	"language.sotho": "Sotho",
	"language.spanish": "Spanisch",
	"language.swazi": "Siswati",
	"language.swedish": "Schwedisch",
	"language.swiss_german": "Schwitzerdütsch",
	"language.syriac": "Syrisch",
	"language.tagalog": "Tagalog",
	"language.tamil": "Tamil",
	"language.telugu": "Telugu",
	"language.thai": "Thailändisch",
	"language.tibetan": "Tibetisch",
	"language.tigrinya": "Tigrinya",
	"language.turkish": "Türkisch",
	"language.ukrainian": "Ukrainisch",
	"language.urdu": "Urdu",
	"language.uzbek": "Uzbekisch",
	"language.vietnamese": "Vietnamesisch",
	"language.welsh": "Walisisch",
	"language.yiddish": "Jiddisch",
	"language.yoruba": "Yoruba",
	"language.yupik": "Yupik",
	"language.zulu": "Zulu",
	"languages.chinese": "Chinesisch",
	"languages.middle_high_german": "Mittelhochdeutsch",
	"languages.russian": "Russisch",
	"languages.serbocroatian": "Serbokroatisch",
	"price.hint.free": "kostenlos"
};

var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["PENDING"] = "pending";
    DeliveryStatus["DELIVERED"] = "delivered";
    DeliveryStatus["ERROR"] = "error";
})(DeliveryStatus || (DeliveryStatus = {}));
var DownloadType;
(function (DownloadType) {
    DownloadType["PDF"] = "PDF";
    DownloadType["EPUB"] = "EPUB";
    DownloadType["WMA"] = "WMA";
    DownloadType["MP3"] = "ESONO";
    DownloadType["UNKNOWN"] = "UNKNOWN";
})(DownloadType || (DownloadType = {}));
const parseDeliveryStatus = (deliveryStatusJson) => {
    const code = Type.number(deliveryStatusJson, 'DigitalArticle.deliveryStatus');
    if (code === 0) {
        return DeliveryStatus.PENDING;
    }
    else if (code >= 200 && code < 300) {
        return DeliveryStatus.DELIVERED;
    }
    else {
        return DeliveryStatus.ERROR;
    }
};
const isDelivered = (digitalArticle) => !!(digitalArticle && digitalArticle.deliveryStatus === DeliveryStatus.DELIVERED);
const isDownloadReady = (digitalArticle) => isDelivered(digitalArticle) && digitalArticle.downloadAllowed;
const parseDownloadType = EnumUtil.parser({
    enumValues: DownloadType,
    enumTypeName: 'DigitalArticle',
    defaultValue: DownloadType.UNKNOWN,
});
const parseItem = (json) => {
    const dateString = Type.optional.string(json.purchaseDate, 'DigitalArticle.purchaseDate');
    return {
        articleId: Type.number(json.articleId, 'DigitalArticle.articleId'),
        downloadId: Type.notEmptyString(json.downloadId, 'DigitalArticle.downloadId'),
        downloadAllowed: Type.boolean(json.downloadAllowed, 'DigitalArticle.downloadAllowed'),
        deliveryStatus: parseDeliveryStatus(json.deliveryStatus),
        tolinoWebreaderUrl: Type.optional.string(json.tolinoWebreaderUrl, 'DigitalArticle.tolinoWebreaderUrl'),
        ePublishingUrl: Type.optional.string(json.EPublishingUrl, 'DigitalArticle.ePublishingUrl'),
        title: Type.optional.string(json.title, 'DigitalArticle.title'),
        authors: Type.optional.string(json.authors, 'DigitalArticle.authors'),
        coverLarge: Type.optional.string(json.imgLarge, 'DigitalArticle.imgLarge'),
        coverLargeWidth: Type.falsyToUndefined.number(json.imgLargeWidth, 'DigitalArticle.imgLargeWidth'),
        coverLargeHeight: Type.falsyToUndefined.number(json.imgLargeHeight, 'DigitalArticle.imgLargeHeight'),
        downloadType: parseDownloadType(Type.optional.string(json.downloadType, 'DigitalArticle.downloadType')),
        orderDate: dateString ? DateUtil.parse(dateString) : undefined,
        orderToken: Type.optional.string(json.orderReference, 'DigitalArticle.orderReference'),
        subscriptionId: Type.optional.number(json.subscriptionId, 'DigitalArticle.subscriptionId'),
    };
};
const parse$i = (json) => {
    const digitalArticlesJson = Type.array(json.items, 'DigitalArticle.items');
    return digitalArticlesJson.map(parseItem);
};
const getByArticleId = (articleId, digitalArticles) => {
    if (!digitalArticles)
        return;
    return digitalArticles.find(item => item.articleId === articleId);
};
const WsDigitalArticle = { parse: parse$i, isDelivered, isDownloadReady, getByArticleId, parseItem };

const WS = {
    download: {
        library: createCustomerCall({
            name: 'download/library',
            parser: WsDigitalArticle.parse,
            method: Method.GET,
        }),
        libraryWithoutTolinoSubscription: createCustomerCall({
            name: 'download/librarywithouttolinosubscription',
            parser: WsPageableList.parserFor(WsDigitalArticle.parseItem),
            method: Method.GET,
        }),
        libraryForTolinoSubscription: createCustomerCall({
            name: 'download/libraryfortolinosubscription',
            parser: WsPageableList.parserFor(WsDigitalArticle.parseItem),
            method: Method.GET,
        }),
    },
};

const category = (naviId, name) => `/de/category/${naviId}/${name}.html`;
const ePublishing = (command) => 'epublishing://' + command;
const ExternalRoutes = {
    ADOBE: '/adobe',
    EKIDZ_ANDROID_APP: 'https://www.ekidz.eu/mobile/?asid=2&pid=1001',
    EKIDZ_IOS_APP: 'https://www.ekidz.eu/mobile/?asid=1&pid=1001',
    HELP_DOWNLOAD_TRANSFER: category(process.env.IS_HUDU ? 79394 : 59440, 'uebertragen_auf_geraete'),
    SUBSCRIPTIONS: '/de/subscriptions',
    TOLINO_ANDROID_APP: 'https://play.google.com/store/apps/details?id=com.mytolino.app',
    TOLINO_IOS_APP: 'https://itunes.apple.com/de/app/tolino-lese-app-ebooks-bucher/id944944881',
    TOLINO_AUDIO_BOOK_LIBRARY: ePublishing('audiobook-library'),
    TOLINO_LIBRARY: ePublishing('library'),
    SHOPPING_CART: '/de/shoppingcart',
    CHECKOUT: '/de/checkout/overview',
};

const PAGING_LIMIT = 10;
const NO_DOWNLOADS = { items: [], results: 0, limit: PAGING_LIMIT, offset: 0 };
const _DigitalArticleService = { NO_DOWNLOADS };
_DigitalArticleService.fetchDigitalArticles = async (types, currentPage, query, sort, asc, subscriptionId) => {
    _DigitalArticleService.lastFetchParams = { types, currentPage, query, sort, asc, subscriptionId };
    const params = {
        downloadType: WsParser.toApiList(types),
        maxResults: PAGING_LIMIT,
        offset: (currentPage - 1) * PAGING_LIMIT,
        searchCriteria: query ? `author=${query},title=${query}` : undefined,
        sortCriteria: sort,
        ascending: asc,
    };
    return (subscriptionId
        ? WS.download.libraryForTolinoSubscription({ ...params, subscriptionId })
        : WS.download.libraryWithoutTolinoSubscription(params)).catch(e => {
        Track.error(TRACK_ID('2020-01-15 01:12:44'), 'Loading download library failed, because: ' + e.message);
        Toaster.open('error.general');
        return NO_DOWNLOADS;
    });
};
const _downloadLoader = (types) => (currentPage, query, sort, asc, subscriptionId) => _DigitalArticleService.fetchDigitalArticles(types, currentPage, query, sort, asc, subscriptionId);
const AUDIO_BOOK_TYPES = [DownloadType.MP3, DownloadType.WMA];
const loadEBooks = _downloadLoader([DownloadType.EPUB, DownloadType.PDF]);
const loadAudioBooks = _downloadLoader(AUDIO_BOOK_TYPES);
const loadSubscriptionLibrary = _downloadLoader([DownloadType.EPUB, DownloadType.PDF]);
const loadByOrderToken = (orderToken) => WS.download.library({ libriReference: orderToken });
const getWebreaderLibraryURL = (audioBooks) => `${Config.get().webreaderBaseUrl}?reseller=${Config.get().tolinoResellerId}&autologin=true#${audioBooks ? '/myaudiobooks/titles' : '/mybooks'}`;
const getWebreaderFamilySharingURL = () => `${Config.get().webreaderBaseUrl}?reseller=${Config.get().tolinoResellerId}&autologin=true#manage-family`;
_DigitalArticleService.openWebreaderLibrary = (audioBooks) => {
    const url = DigitalArticleService.getWebreaderLibraryURL(audioBooks);
    return DownloadService.applyOAuthCode(url).then(authorizedUrl => ClientNavigation.open(authorizedUrl || url));
};
_DigitalArticleService.openTolinoLibrary = (audioBooks) => ClientNavigation.open(audioBooks ? ExternalRoutes.TOLINO_AUDIO_BOOK_LIBRARY : ExternalRoutes.TOLINO_LIBRARY);
_DigitalArticleService.openLibrary = (audioBooks) => _DigitalArticleService.openWebreaderLibrary(audioBooks);
const openEBookLibrary = () => _DigitalArticleService.openLibrary(false);
const openAudioBookLibrary = () => _DigitalArticleService.openLibrary(true);
const readerUrl = (digitalArticle) => digitalArticle === null || digitalArticle === void 0 ? void 0 : digitalArticle.tolinoWebreaderUrl;
_DigitalArticleService.openReader = async (readingUrl) => {
    await DownloadService.applyOAuthCode(readingUrl).then(authorizedUrl => ClientNavigation.open(authorizedUrl || readingUrl));
};
_DigitalArticleService.getUpdatedDigitalArticles = () => {
    if (!_DigitalArticleService.lastFetchParams)
        return Promise.resolve(undefined);
    const { types, currentPage, query, sort, asc, subscriptionId } = _DigitalArticleService.lastFetchParams;
    return _DigitalArticleService.fetchDigitalArticles(types, currentPage, query, sort, asc, subscriptionId);
};
_DigitalArticleService.getUpdatedDigitalArticle = (digitalArticle) => _DigitalArticleService.getUpdatedDigitalArticles().then(
// try to find the requested digitalArticle in the returned list
// ATTENTION: We might get problems here, when the customer bought some more digitalArticles
//            in a different tab in the meanwhile. Meaning that the requested digitalArticle might vanish
//            from (or at least move inside) the displayed digitalArticles.
//            But this should be a very rare corner case.
digitalArticles => digitalArticles === null || digitalArticles === void 0 ? void 0 : digitalArticles.items.find(({ downloadId }) => downloadId === digitalArticle.downloadId));
const isAudioBook = ({ downloadType }) => AUDIO_BOOK_TYPES.includes(downloadType);
/**
 * The returned promise returns if the request was successful. In that case the customer will be
 * redirected to some different place. But in the other case, we need to display some feedback.
 */
const openReader = async (digitalArticle) => {
    const readerUrl = DigitalArticleService.readerUrl(digitalArticle);
    if (!readerUrl) {
        // this might be the case if the digitalArticle was freshly bought and the order is still pending
        // each time the customer clicks the button, we retry if this status changed already
        const updated = await _DigitalArticleService.getUpdatedDigitalArticle(digitalArticle);
        const updatedReadingUrl = DigitalArticleService.readerUrl(updated);
        if (!updatedReadingUrl)
            return false;
        await _DigitalArticleService.openReader(updatedReadingUrl);
        return true;
    }
    await _DigitalArticleService.openReader(readerUrl);
    return true;
};
_DigitalArticleService.openDigitalArticle = ({ downloadId }) => DownloadService.pollUrl(downloadId).then(url => {
    if (url) {
        ClientNavigation.open(url);
        return true;
    }
    return false;
});
/**
 * The returned promise returns if the request was successful. In that case the customer will start
 * to download the article. But in the other case, we need to display some feedback.
 */
const openDigitalArticle = async (digitalArticle) => {
    if (!WsDigitalArticle.isDelivered(digitalArticle)) {
        // this might be the case if the digitalArticle was freshly bought and the order is still pending
        // each time the customer clicks the button, we retry if this status changed already
        const updated = await _DigitalArticleService.getUpdatedDigitalArticle(digitalArticle);
        if (!WsDigitalArticle.isDelivered(updated))
            return false;
        return _DigitalArticleService.openDigitalArticle(updated);
    }
    return _DigitalArticleService.openDigitalArticle(digitalArticle);
};
const DigitalArticleService = {
    loadEBooks,
    loadAudioBooks,
    loadByOrderToken,
    PAGING_LIMIT,
    openEBookLibrary,
    openAudioBookLibrary,
    loadSubscriptionLibrary,
    readerUrl,
    openReader,
    openDigitalArticle,
    isAudioBook,
    getWebreaderLibraryURL,
    getWebreaderFamilySharingURL,
};

const ArticleTypeView = ({ productTypeDescription }) => (React.createElement("div", { className: "item-type" }, productTypeDescription));

const ArticleTitleUtil = {
    couponTitle: () => process.env.IS_HUDU ? { id: 'articleTitle.item.GiftCard' } : { id: 'articleTitle.item.Coupon' },
};
const ArticleTitle = ({ isCoupon, title, shortened }) => (React.createElement("div", { className: "title" }, isCoupon ? (__(ArticleTitleUtil.couponTitle())) : shortened ? (React.createElement(Shortened, { maxLength: 35 }, title)) : (title)));

const DiscountBadge = ({ price, oldPrice, rebateCategory, calculatedDiscount }) => {
    const rebateCategoryNumber = Number(rebateCategory !== null && rebateCategory !== void 0 ? rebateCategory : 0);
    let discountPercent = calculatedDiscount;
    if (!calculatedDiscount) {
        const canCalculateDiscount = price && oldPrice && price < oldPrice;
        if (!canCalculateDiscount) {
            return null;
        }
        const calculatedDiscountPercent = DiscountUtil.calculate(price, oldPrice);
        if (!calculatedDiscountPercent) {
            return null;
        }
        discountPercent = `-${calculatedDiscountPercent}%`;
    }
    return (React.createElement("span", { className: "discount-badge" },
        discountPercent,
        rebateCategoryNumber > 0 && React.createElement("span", { className: "footnote-ref" }, rebateCategoryNumber)));
};

const coverUri = (coverPath, isCoupon) => {
    const mediaBaseUrl = Config.get().mediaBaseUrl;
    if (isCoupon) {
        const couponUriPart = process.env.IS_HUDU
            ? 'hudu/geschenkkarte/geschenkkarte'
            : 'ebookde/geschenkgutschein/geschenkgutschein';
        return `${mediaBaseUrl}/magazine-pictures/${couponUriPart}_cart.png`;
    }
    if (!coverPath) {
        return `${mediaBaseUrl}/images/no_cover_large.jpg`;
    }
    if (coverPath.startsWith('https://')) {
        return coverPath;
    }
    return UrlUtil.coverUri(mediaBaseUrl, coverPath);
};
const CoverImg = ({ coverPath, title, isCoupon, price, oldPrice, rebateCategory, priceDisruptor, }) => {
    const imageUri = coverUri(coverPath, isCoupon);
    const alternativeAttribute = isCoupon
        ? __string(ArticleTitleUtil.couponTitle())
        : title || __string('coverImage.altCover');
    return (React.createElement("div", { className: "cover-img" },
        React.createElement(Img, { src: imageUri, alt: alternativeAttribute }),
        React.createElement(DiscountBadge, { price: price, oldPrice: oldPrice, rebateCategory: rebateCategory, calculatedDiscount: priceDisruptor })));
};

const RecommendationProductDetails = ({ binder, title, authors, coverPath, price, oldPrice, rebateCategory, priceDisruptor, }) => (React.createElement(React.Fragment, null,
    React.createElement(CoverImg, { coverPath: coverPath, title: title, price: price, oldPrice: oldPrice, rebateCategory: rebateCategory, priceDisruptor: priceDisruptor }),
    React.createElement("div", { className: "details" },
        binder && React.createElement(ArticleTypeView, { productTypeDescription: binder }),
        title && React.createElement("div", { className: "title line-clamp-l2" }, title),
        authors && React.createElement("div", { className: "author" }, authors))));

const WrapLink = ({ productUrl, children, onClick, }) => {
    if (!productUrl) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(A, { trackId: TRACK_ID('2020-07-13 12:45:00'), href: productUrl, onClick: onClick }, children));
};
const RecommendationCarouselItem = ({ item: { articleId, availabilityData, coverLargeImagePath, download, title, authors, oldPrice, pickupPossible, price, priceDisruptor, oldPriceText, rebateCategory, productTypeName, trackingToken, }, noTracking, addToBasketCallback, }) => {
    const trackRecommendationClick = useCallback(() => {
        if (noTracking) {
            return;
        }
        if (!trackingToken) {
            return Track$1.error(TRACK_ID('2021-09-07 14:18:00'), 'Prudsys recommendation without trackingToken for Id: ' + articleId);
        }
        return Track$1.recommendationClick(articleId, trackingToken);
    }, [articleId, noTracking, trackingToken]);
    const productUrl = useMemo(() => {
        if (productTypeName && title && articleId) {
            return LinkUtil.buildArticleDetailPageLink(articleId, productTypeName, title, authors);
        }
    }, [articleId, title, productTypeName, authors]);
    const addToBasket = useCallback(() => {
        const mappedRecommendationItem = {
            articleId,
            availabilityData,
            coverLargeImagePath,
            download,
            pickupPossible,
            price,
            authors,
            title,
            productTypeName,
        };
        trackRecommendationClick();
        addToBasketCallback(mappedRecommendationItem);
    }, [
        articleId,
        authors,
        availabilityData,
        coverLargeImagePath,
        download,
        pickupPossible,
        price,
        title,
        addToBasketCallback,
        productTypeName,
        trackRecommendationClick,
    ]);
    return (React.createElement("div", { className: "article-list-entry product-item" },
        React.createElement(WrapLink, { productUrl: productUrl, onClick: trackRecommendationClick },
            React.createElement(RecommendationProductDetails, { binder: productTypeName ? productTypeName : '', title: title ? title : '', authors: authors, coverPath: coverLargeImagePath, price: price, oldPrice: oldPrice, rebateCategory: rebateCategory, priceDisruptor: priceDisruptor })),
        price !== undefined && (React.createElement(Button, { className: _.classNames('btn btn-primary btn-sm add-to-cart-btn'), type: "button", onClick: addToBasket }, Money.getFormatted(price))),
        !!oldPrice && (React.createElement("div", { className: "additional-item-info" },
            React.createElement("span", { className: "price price-secondary" },
                oldPriceText && oldPriceText,
                " ",
                Money.getFormatted(oldPrice),
                rebateCategory !== undefined && rebateCategory != 0 && (React.createElement("span", { className: "footnote-ref" }, rebateCategory)))))));
};

const BREAK_AMOUNTS$2 = {
    [CSSBreakPoint.XS]: 2,
    [CSSBreakPoint.SM]: 3,
    [CSSBreakPoint.M]: 4,
    [CSSBreakPoint.L]: 4,
};
const RecommendationCarousel = ({ breakAmounts, recommendations, headline, classes, addToBasket, }) => {
    const amount = useCarouselAmount(breakAmounts || BREAK_AMOUNTS$2);
    return (React.createElement(Carousel, { headline: headline, amount: amount, className: _.classNames('recommendations', classes === null || classes === void 0 ? void 0 : classes.carousel) }, recommendations.map((item) => (React.createElement(RecommendationCarouselItem, { key: item.articleId, addToBasketCallback: addToBasket, item: item })))));
};

const _getProperties = (item) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if ('articleAttributeView' in item) {
        // article is of type Article
        const coverPath = ((_a = item.articleAttributeView) === null || _a === void 0 ? void 0 : _a.imgLarge)
            ? (_b = item.articleAttributeView) === null || _b === void 0 ? void 0 : _b.imgLarge
            : (_c = item.articleAttributeView) === null || _c === void 0 ? void 0 : _c.imgExtraLarge;
        const articlePrice = item.articlePrices !== undefined ? item.articlePrices[0].price : Money.parse(0);
        const productTypeDisplayName = (_d = item.productType) === null || _d === void 0 ? void 0 : _d.displayName;
        return [
            item.id,
            (_e = item.articleAttributeView) === null || _e === void 0 ? void 0 : _e.title,
            (_f = item.articleAttributeView) === null || _f === void 0 ? void 0 : _f.authorList,
            coverPath,
            articlePrice,
            productTypeDisplayName,
        ];
    }
    if ('wishlistId' in item) {
        // article is of type WishlistItem
        return [
            item.articleId,
            item === null || item === void 0 ? void 0 : item.title,
            item === null || item === void 0 ? void 0 : item.authors,
            item === null || item === void 0 ? void 0 : item.coverUrlLarge,
            item === null || item === void 0 ? void 0 : item.price,
            (_g = item === null || item === void 0 ? void 0 : item.productType) === null || _g === void 0 ? void 0 : _g.displayName,
        ];
    }
    // article is of type ArticleListEntry
    const recommendationItem = item;
    return [
        recommendationItem === null || recommendationItem === void 0 ? void 0 : recommendationItem.articleId,
        recommendationItem === null || recommendationItem === void 0 ? void 0 : recommendationItem.title,
        recommendationItem === null || recommendationItem === void 0 ? void 0 : recommendationItem.authors,
        recommendationItem === null || recommendationItem === void 0 ? void 0 : recommendationItem.coverLargeImagePath,
        recommendationItem === null || recommendationItem === void 0 ? void 0 : recommendationItem.price,
        recommendationItem === null || recommendationItem === void 0 ? void 0 : recommendationItem.productTypeName,
    ];
};
const ArticleItem = ({ item }) => {
    const [articleId, articleTitle, authorList, coverPath, articlePrice, productTypeDisplayName] = _getProperties(item);
    const articleLink = articleId
        ? LinkUtil.buildArticleDetailPageLink(articleId, productTypeDisplayName, articleTitle, authorList)
        : '#';
    return (React.createElement("div", { className: "article-list-entry article-item" },
        React.createElement(CoverImg, { coverPath: coverPath, title: articleTitle }),
        React.createElement("div", { className: "details" },
            React.createElement(A, { className: "title", trackId: TRACK_ID('2021-10-27 13:53:15'), href: articleLink },
                React.createElement("div", { className: "title" }, articleTitle)),
            React.createElement("div", { className: "author" }, authorList)),
        React.createElement("div", { className: "secondary-item-info" },
            productTypeDisplayName && React.createElement(ArticleTypeView, { productTypeDescription: productTypeDisplayName }),
            React.createElement("div", { className: _.classNames('price price-default price-left') }, articlePrice !== undefined && Money.getFormatted(articlePrice)))));
};

const BREAK_AMOUNTS$1 = {
    [CSSBreakPoint.XS]: 2,
    [CSSBreakPoint.SM]: 3,
    [CSSBreakPoint.M]: 4,
    [CSSBreakPoint.L]: 4,
};
const _getChildren = (articles) => articles.map(item => React.createElement(ArticleItem, { key: item.id, item: item }));
const ArticleToBasketLayer = ({ addToBasket, close, articles, recommendations, classes, }) => {
    const amount = useCarouselAmount(BREAK_AMOUNTS$1);
    const articleElements = useMemo(() => _getChildren(articles), [articles]);
    return (React.createElement("div", { className: "article-to-basket" },
        articleElements.length > 1 ? (React.createElement(React.Fragment, null,
            React.createElement(Carousel, { headline: {
                    id: 'article.addToBasket.heading.sub.multi',
                    values: { count: articleElements.length },
                }, children: articleElements, amount: amount, className: "small-space recommendations" }))) : (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "h2" }, __('article.addToBasket.heading.sub.single')),
            articleElements[0])),
        !!(recommendations === null || recommendations === void 0 ? void 0 : recommendations.length) && (React.createElement(React.Fragment, null,
            React.createElement(RecommendationCarousel, { classes: classes === null || classes === void 0 ? void 0 : classes.recommendationCarousel, headline: {
                    id: articles.length > 1
                        ? 'article.addToBasket.multi.recommendationHeading'
                        : 'article.addToBasket.single.recommendationHeading',
                }, recommendations: recommendations, addToBasket: addToBasket }))),
        React.createElement("div", { className: "buttons" },
            React.createElement(Button, { className: "btn btn-default cancel", label: "article.addToBasket.button.back", type: "button", onClick: close }),
            React.createElement(A, { className: "btn btn-primary btn-lg", href: ExternalRoutes.SHOPPING_CART, trackId: TRACK_ID('2021-07-26 12:59:00') }, __('article.addToBasket.button.forward')))));
};

const openArticleToBasketLayer = (items, recommendations) => {
    Modal.open(React.createElement(ArticleToBasketLayer, { addToBasket: addToBasket, articles: items, recommendations: recommendations === null || recommendations === void 0 ? void 0 : recommendations.products, close: Modal.close, classes: { recommendationCarousel: { carousel: 'small-space' } } }), 'article.addToBasket.heading');
};
// add one article to the basket and show the modal with recommendations
const addToBasket = (item, info) => {
    const id = 'articleId' in item ? item.articleId : item.id;
    if (!id)
        return Promise.reject();
    Modal.close();
    return BasketService.addToCart(id, info)
        .then(recommendations => openArticleToBasketLayer([item], recommendations))
        .catch(e => {
        if (e.errorCode === WsErrorCode.NO_SUCH_ARTICLE) {
            Toaster.open('article.addToBasket.no.article.error');
        }
        else {
            Toaster.open('article.addToBasket.error');
        }
        Track.error(TRACK_ID('2021-08-29 13:19:00'), `Track an error on addToCart: ${e.message}d`);
    });
};
// add all articles to the basket and show the modal with recommendations
const addAllToBasket = (items, info) => BasketService.addAllToCart(items.map(item => item.id), info)
    .then(recommendations => openArticleToBasketLayer(items, recommendations))
    .catch(e => {
    Toaster.open('article.addToBasket.error');
    Track.error(TRACK_ID('2021-08-29 13:20:00'), `Track an error on addToCart: ${e.message}`);
});
// add all articles in the wishlist to the basket and show the modal with recommendations
const addWishlistToBasket = (wishlistId, items) => BasketService.addWishlistToCart(wishlistId, items.map(item => item.articleId))
    .then(recommendations => openArticleToBasketLayer(items, recommendations))
    .catch(e => {
    Toaster.open('article.addToBasket.error');
    Track.error(TRACK_ID('2021-08-29 13:21:00'), `Track an error on addToCart: ${e.message}`);
});
const addDownloadGiftToCart = async (downloadGift, item) => {
    try {
        const recommendations = await BasketService.addDownloadGiftToCart(downloadGift);
        openArticleToBasketLayer([item], recommendations);
    }
    catch (e) {
        Toaster.open('article.addToBasket.error');
        Track.error(TRACK_ID('2022-05-04 11:27:00'), `Track an error on addToCart: ${e.message}`);
    }
};
const BasketModals = { addToBasket, addAllToBasket, addWishlistToBasket, addDownloadGiftToCart };

const AddToCartButton = ({ variant = 'LARGE', label = 'button.addToCart', cartItem, info, onSuccess, }) => {
    const [submitting, addToCart] = useProgressCallback(async () => {
        await BasketModals.addToBasket(cartItem, info);
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
    });
    const variantClassNames = variant === 'LARGE' ? 'btn-lg' : 'btn-sm btn-icon-right btn-add-to-basket';
    return (React.createElement(Button, { className: _.classNames('btn btn-primary', variantClassNames), label: label, loading: submitting, onClick: addToCart },
        React.createElement("span", { className: "icon icon-cart-white" })));
};

const ArticleAuthors = ({ authors, prefixed, shouldRedirectToAdvancedSearch }) => {
    const className = _.classNames('author', shouldRedirectToAdvancedSearch && 'author-advanced');
    const renderContent = () => {
        const maxLength = prefixed ? 17 : 50;
        return (React.createElement(React.Fragment, null,
            prefixed && __('authors.from'),
            "\u00A0",
            React.createElement(Shortened, { maxLength: maxLength }, authors)));
    };
    if (!(authors === null || authors === void 0 ? void 0 : authors.length)) {
        return null;
    }
    if (!shouldRedirectToAdvancedSearch) {
        return React.createElement("div", { className: className }, renderContent());
    }
    return (React.createElement(A, { className: className, trackId: TRACK_ID('2022-11-29 15:35:51'), href: `/de/search/advanced?authors=${encodeURIComponent(authors)}` }, renderContent()));
};

const ArticleAvailability = ({ availabilityData, publicationDate, preOrderMessage, }) => (React.createElement("div", { className: availabilityData.currentlyAvailable ? 'availability immediately' : '' },
    React.createElement("span", null, availabilityData.text),
    preOrderMessage && publicationDate && publicationDate > new Date() && (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "label" }, preOrderMessage),
        React.createElement("span", { className: "value" },
            React.createElement(DateTag, { date: publicationDate }))))));

const ArticleDeliveryDates = ({ dateOfDeliveryMin, dateOfDeliveryMax }) => (React.createElement(React.Fragment, null,
    React.createElement("span", { className: "label" }, __('article.delivery')),
    React.createElement("span", { className: "value" },
        React.createElement(DateTag, { date: dateOfDeliveryMin, withWeekday: true }),
        ' - ',
        React.createElement(DateTag, { date: dateOfDeliveryMax, withWeekday: true }))));

const ArticleSinglePrice = ({ articlePrice: { price, priceLabel, oldPrice, oldPriceLabel, rebateCategory, rebateDescription }, }) => {
    if (price === undefined)
        return null; //have to check for undefined explicitly for "0" should be rendered as price
    if (!oldPrice || oldPrice < price)
        return React.createElement("span", { className: "price price-default" }, Money.getFormatted(price));
    return (React.createElement(React.Fragment, null,
        priceLabel && (React.createElement("div", { className: "price-info price-label" },
            priceLabel,
            rebateCategory && React.createElement("span", { className: "footnote-ref" }, rebateCategory))),
        React.createElement("span", { className: "price price-reduced" }, Money.getFormatted(price)),
        oldPriceLabel && (React.createElement("div", { className: "price-info" },
            React.createElement("span", { className: "price-label" }, oldPriceLabel),
            React.createElement("span", { className: "price price-old" },
                Money.getFormatted(oldPrice),
                rebateCategory && React.createElement("span", { className: "footnote-ref" }, rebateCategory)))),
        rebateDescription && React.createElement("div", { className: "price-info rebate-description" }, rebateDescription)));
};

const ArticleFilter = ({ sortOptions, useFilter, defaultFilter }) => {
    const { search } = useLocation();
    const navigate = useNavigate();
    const filter = useFilter();
    const onFilterOptionChange = useCallback((filter) => {
        const query = UrlUtil.locationSearchToQuery(search);
        navigate(UrlUtil.updateSearch({
            ...query,
            filter: filter === defaultFilter ? undefined : filter,
            page: undefined,
        }));
    }, [defaultFilter, navigate, search]);
    return (React.createElement(Select, { className: "label-hidden", name: "filter-articleType", label: { id: 'article.filter.label' }, onChange: onFilterOptionChange, options: sortOptions, value: filter }));
};

var SortCriteriaCustomer;
(function (SortCriteriaCustomer) {
    SortCriteriaCustomer["DATE"] = "date";
    SortCriteriaCustomer["TITLE"] = "title";
    SortCriteriaCustomer["AUTHOR"] = "author";
    SortCriteriaCustomer["PRICE"] = "price";
})(SortCriteriaCustomer || (SortCriteriaCustomer = {}));
var SortCriteriaSearch;
(function (SortCriteriaSearch) {
    SortCriteriaSearch["TOP"] = "score";
    SortCriteriaSearch["DATE"] = "publication";
    SortCriteriaSearch["TITLE"] = "title";
    SortCriteriaSearch["AUTHOR"] = "authors";
    SortCriteriaSearch["PRICE"] = "price";
})(SortCriteriaSearch || (SortCriteriaSearch = {}));
const DEFAULT_SORT_CRITERIA_CUSTOMER = SortCriteriaCustomer.DATE;
const DEFAULT_SORT_CRITERIA_SEARCH = SortCriteriaSearch.TOP;

const parseSort = EnumUtil.parser({
    enumValues: SortCriteriaCustomer,
    defaultValue: DEFAULT_SORT_CRITERIA_CUSTOMER,
    enumTypeName: 'SortCriteriaCustomer',
});
const parseSortSearch = EnumUtil.parser({
    enumValues: SortCriteriaSearch,
    defaultValue: DEFAULT_SORT_CRITERIA_SEARCH,
    enumTypeName: 'SortCriteriaSearch',
});
const _getSortFromSearch = (search, inSearchApp) => {
    const currentSortOption = UrlUtil.locationSearchToQuery(search).sort;
    return inSearchApp
        ? parseSortSearch(currentSortOption || DEFAULT_SORT_CRITERIA_SEARCH)
        : parseSort(currentSortOption || DEFAULT_SORT_CRITERIA_CUSTOMER);
};
const _getAscendingFromSearch = (search) => UrlUtil.locationSearchToQuery(search).asc === 'true';
const useCurrentSort = (inSearchApp = false) => {
    const { search } = useLocation();
    return useMemo(() => _getSortFromSearch(search, inSearchApp), [inSearchApp, search]);
};
const useCurrentAscending = () => {
    const { search } = useLocation();
    return useMemo(() => _getAscendingFromSearch(search), [search]);
};
const parseSortOption = (sortOption) => {
    const [sort, ascString] = sortOption.split('-');
    return { sort: sort, asc: ascString === 'true' };
};
const getSortOption = (sort, asc) => `${sort}-${asc}`;
const useCurrentSortOption = (inSearchApp) => {
    const sort = useCurrentSort(inSearchApp);
    const asc = useCurrentAscending();
    return useMemo(() => getSortOption(sort, asc), [sort, asc]);
};

const ArticleSort = ({ sortOptions, label, inSearchApp = false }) => {
    const { search } = useLocation();
    const navigate = useNavigate();
    const sortOption = useCurrentSortOption(inSearchApp);
    const onSortOptionChange = useCallback((sortOption) => {
        const query = UrlUtil.locationSearchToQuery(search, true);
        const { sort, asc } = parseSortOption(sortOption);
        const defaultCriteria = inSearchApp ? DEFAULT_SORT_CRITERIA_SEARCH : DEFAULT_SORT_CRITERIA_CUSTOMER;
        navigate(UrlUtil.updateSearch({
            ...query,
            sort: sort === defaultCriteria ? undefined : sort,
            asc: asc ? 'true' : undefined,
        }, undefined, !!inSearchApp));
    }, [inSearchApp, navigate, search]);
    return (React.createElement(Select, { className: "label-hidden", name: "filter-articleType", label: { id: label }, options: sortOptions, onChange: onSortOptionChange, value: sortOption }));
};

const QuickBuyButton = ({ productId, info }) => {
    const navigate = useNavigate();
    const handleQuickBuy = useCallback(async () => {
        await Cart.quickBuy(productId, info);
        navigate(ExternalRoutes.CHECKOUT);
    }, [productId, info, navigate]);
    return (React.createElement(Button, { className: "btn btn-default btn-sm", label: "article.ock.button", onClick: handleQuickBuy },
        React.createElement("span", { className: "icon icon-download-dark" })));
};

const AppTeaserEkidz = () => (React.createElement(React.Fragment, null,
    React.createElement("p", { className: "help-appStores" }, __({
        id: 'digital-articles.ekidzApp',
    })),
    React.createElement("p", { className: "app-stores" },
        React.createElement(A, { className: "googleplay-store", trackId: TRACK_ID('2020-07-13 15:43:12'), href: ExternalRoutes.EKIDZ_ANDROID_APP, external: true, target: "_blank" }, __('digital-articles.ekidzApp.android')),
        React.createElement(A, { className: "appleapp-store", trackId: TRACK_ID('2020-07-13 15:43:12'), href: ExternalRoutes.EKIDZ_IOS_APP, external: true, target: "_blank" }, __('digital-articles.ekidzApp.iOS')))));

const AppTeaserTolino = () => (React.createElement(React.Fragment, null,
    React.createElement("p", { className: "help-tolinoApp" }, __({
        id: 'digital-articles.tolinoApp',
        values: {
            tolinoAppName: React.createElement("span", { className: "text-highlighting" }, __('digital-articles.tolinoApp.name')),
        },
    })),
    React.createElement("p", { className: "app-stores" },
        React.createElement(A, { className: "googleplay-store", trackId: TRACK_ID('2019-10-17 02:44:56'), href: ExternalRoutes.TOLINO_ANDROID_APP, external: true, target: "_blank" }, __('digital-articles.tolinoApp.android')),
        React.createElement(A, { className: "appleapp-store", trackId: TRACK_ID('2019-10-17 02:44:56'), href: ExternalRoutes.TOLINO_IOS_APP, external: true, target: "_blank" }, __('digital-articles.tolinoApp.iOS')))));

const DigitalArticleCover = ({ digitalArticle: { title, coverLarge } }) => (React.createElement("div", { className: "cover-col col col-xs-4 col-sm-2" },
    React.createElement(CoverImg, { coverPath: coverLarge, title: title })));

const DigitalArticleDetails = ({ digitalArticle: { title, orderDate, authors, orderToken, subscriptionId }, }) => (React.createElement("div", { className: "details-col col col-xs-8 col-sm-6" },
    React.createElement("div", { className: "primary-item-info" },
        React.createElement("div", { className: "title" }, title),
        React.createElement("div", { className: "author" }, authors)),
    !subscriptionId && (React.createElement("div", { className: "order-item-info" },
        orderDate && (React.createElement(React.Fragment, null,
            React.createElement("label", null, __('digital-articles.orderDate')),
            React.createElement("span", { className: "value" }, DateUtil.toGermanString(orderDate)),
            React.createElement("br", null))),
        React.createElement("label", null, __('digital-articles.orderNumber')),
        React.createElement("span", { className: "value" }, orderToken)))));

const DownloadReaderButton = ({ download, loading, onClick }) => {
    const readerUrl = DigitalArticleService.readerUrl(download);
    const isAudioBook = DigitalArticleService.isAudioBook(download);
    return (React.createElement(Button, { onClick: onClick, className: _.classNames('btn', readerUrl ? 'btn-primary' : 'btn-default'), label: isAudioBook ? 'button.listen' : 'button.read', loading: loading }));
};

const HINT_DISPLAY_TIME = 5000;
const DownloadActionButtons = ({ digitalArticle, onShowHint, withDownloadIcon }) => {
    const showDownloadLink = !digitalArticle.subscriptionId;
    const isDelivered = WsDigitalArticle.isDelivered(digitalArticle);
    const wrapDownloadHandler = useCallback((handler) => () => {
        // hide hint directly after click
        onShowHint(false);
        return handler(digitalArticle).then(success => {
            if (!success) {
                // display hint if the request did not succeed
                onShowHint(true);
                // automatically remove the hint after some delay
                _.sleep(HINT_DISPLAY_TIME).then(() => onShowHint(false));
            }
        });
    }, [digitalArticle, onShowHint]);
    const [loadingReader, openReader] = useProgressCallback(wrapDownloadHandler(DigitalArticleService.openReader));
    const [loadingDownload, onDownload] = useProgressCallback(wrapDownloadHandler(DigitalArticleService.openDigitalArticle));
    return (React.createElement(React.Fragment, null,
        React.createElement(DownloadReaderButton, { download: digitalArticle, loading: loadingReader, onClick: openReader }),
        showDownloadLink && (React.createElement(Button, { className: _.classNames('btn', isDelivered ? 'btn-primary' : 'btn-default', withDownloadIcon && 'btn-icon-only btn-download'), label: "button.download", loading: loadingDownload, onClick: onDownload }))));
};

const DownloadActions = ({ download }) => {
    const [showHint, setShowHint] = useSafeState(false);
    return (React.createElement("div", { className: "action-col col-xs-8 col-sm-4" },
        React.createElement(DownloadActionButtons, { digitalArticle: download, onShowHint: setShowHint }),
        showHint && React.createElement("span", { className: "message active" }, __('digital-articles.notReady'))));
};

const DigitalArticleView = ({ digitalArticle }) => (React.createElement("div", { className: "library-item article-item col-12" },
    React.createElement("div", { className: "row" },
        React.createElement(DigitalArticleCover, { digitalArticle: digitalArticle }),
        React.createElement(DigitalArticleDetails, { digitalArticle: digitalArticle }),
        React.createElement(DownloadActions, { download: digitalArticle }))));

const DigitalArticleList = ({ digitalArticles }) => (React.createElement("div", { className: "article-list" },
    React.createElement(Pager, { results: digitalArticles.results, pagingAmount: DigitalArticleService.PAGING_LIMIT }),
    digitalArticles.items.map(download => (React.createElement(DigitalArticleView, { digitalArticle: download, key: download.downloadId }))),
    React.createElement(Pager, { results: digitalArticles.results, pagingAmount: DigitalArticleService.PAGING_LIMIT })));

const initialValues = { query: '' };
const initialData = { values: initialValues, errors: {} };
const { Form, Fields } = TrackingForm.create(initialValues, TRACK_ID('2020-01-24 10:02:29'), { allowMultiSubmit: true });
const validation = {};
const DigitalArticleSearchFilter = () => {
    const navigate = useNavigate();
    const [data, setData] = useState(initialData);
    const query = useCurrentQuery();
    const lastQuery = useRef(query);
    // if the query changed in the search to some value that does not match the
    // currently entered value -> we update the value in the input
    // this has the positive site effect of enabling prefilling on page reloads
    useEffect(() => {
        if (query !== lastQuery.current) {
            lastQuery.current = query;
            setData(data => ({ ...data, values: { query } }));
        }
    }, [query]);
    const onSubmit = ({ query }) => navigate(UrlUtil.updateSearch({ query: query.trim() || undefined }));
    return (React.createElement(Form, { data: data, validation: validation, onSubmit: onSubmit, onChange: setData, className: "article-search-form input-group" },
        React.createElement(FormInput, { Field: Fields.query, className: "article-search-field form-field no-label", placeholder: "digital-articles.filter.search" }),
        React.createElement(Button, { className: "btn btn-primary btn-icon-only icon-search", label: "button.search" })));
};

const SORT_OPTIONS = [
    { label: { id: 'digital-articles.sort.date.desc' }, value: getSortOption(SortCriteriaCustomer.DATE, false) },
    { label: { id: 'digital-articles.sort.date.asc' }, value: getSortOption(SortCriteriaCustomer.DATE, true) },
    { label: { id: 'digital-articles.sort.title.desc' }, value: getSortOption(SortCriteriaCustomer.TITLE, false) },
    { label: { id: 'digital-articles.sort.title.asc' }, value: getSortOption(SortCriteriaCustomer.TITLE, true) },
    { label: { id: 'digital-articles.sort.author.desc' }, value: getSortOption(SortCriteriaCustomer.AUTHOR, false) },
    { label: { id: 'digital-articles.sort.author.asc' }, value: getSortOption(SortCriteriaCustomer.AUTHOR, true) },
];
const DigitalArticleFilters = () => (React.createElement("div", { className: "row filter-actions" },
    React.createElement("div", { className: "col-sm-8" },
        React.createElement(DigitalArticleSearchFilter, null)),
    React.createElement("div", { className: "col-sm-4" },
        React.createElement(ArticleSort, { sortOptions: SORT_OPTIONS, label: 'article.sort.label' }))));

const DigitalArticles = ({ digitalArticles, noResultsMsg }) => {
    const query = useCurrentQuery();
    const hasNoResults = Boolean(digitalArticles && !digitalArticles.results);
    const showNoDownloads = Boolean(hasNoResults && !query);
    const showNoSearchResults = Boolean(hasNoResults && query);
    const showFilters = Boolean(query || (digitalArticles === null || digitalArticles === void 0 ? void 0 : digitalArticles.results));
    return (React.createElement("div", { className: "library-item-list" },
        showNoDownloads && React.createElement("div", { className: "no-results message info" }, __(noResultsMsg)),
        showFilters && React.createElement(DigitalArticleFilters, null),
        showNoSearchResults && React.createElement("div", { className: "no-results" }, __('digital-articles.search.noResults')),
        digitalArticles && !hasNoResults && React.createElement(DigitalArticleList, { digitalArticles: digitalArticles }),
        !digitalArticles && React.createElement(AreaSpinner, { className: "row article-list" })));
};

const HelpTeaser = ({ audioBooks }) => (React.createElement("div", { className: "help-links" },
    React.createElement(IconTeaser, { trackId: TRACK_ID('2019-03-14 04:33:29'), text: __string(audioBooks ? 'audioBooks.help.downloads' : 'eBooks.help.adobeId'), linkText: audioBooks ? '' : __string('digital-articles.adobeId.link'), linkHref: audioBooks ? '' : ExternalRoutes.ADOBE, iconClass: 'icon-big-download', iconSize: 'icon-size-small', showSmallLink: true, externalLink: true }),
    React.createElement(IconTeaser, { trackId: TRACK_ID('2019-03-14 04:33:29'), text: __string(audioBooks ? 'audioBooks.help.transfer' : 'eBooks.help.transfer'), linkText: __string(audioBooks ? 'audioBooks.help.transfer.linkText' : 'eBooks.help.transfer.linkText'), linkHref: ExternalRoutes.HELP_DOWNLOAD_TRANSFER, iconClass: 'icon-big-tablet', iconSize: 'icon-size-small', showSmallLink: true, externalLink: true })));

const LanguageCodeMapping = {
    SCG: 'language.czech',
    CZE: 'language.czech',
    NA: 'language.czech',
    CHE: 'language.czech',
    EN: 'language.english',
    ENM: 'language.english',
    ENG: 'language.english',
    AFG: 'language.dutch',
    DUT: 'language.dutch',
    Hindi: 'language.hindi',
    HI: 'language.hindi',
    HIN: 'language.hindi',
    JA: 'language.japanese',
    JAP: 'language.japanese',
    JPN: 'language.japanese',
    ROU: 'language.romanian',
    RUM: 'language.romanian',
    MUL: 'language.multi',
    SCC: 'language.serbian',
    SRP: 'language.serbian',
    SAN: 'language.sanskrit',
    FRM: 'language.french',
    FRI: 'language.french',
    FRE: 'language.french',
    FRA: 'language.french',
    GMH: 'languages.middle_high_german',
    DE: '',
    GER: '',
    DEU: '',
    SLO: 'language.slovak',
    PER: 'language.persian',
    IND: 'language.indonesian',
    LAV: 'language.latvian',
    SLV: 'language.slovene',
    EGY: 'language.egypt',
    GEO: 'language.georgian',
    TGL: 'language.filipino',
    NDS: 'language.low_german',
    ICE: 'language.icelandic',
    MON: 'language.mongolian',
    SWE: 'language.swedish',
    AFH: 'language.afrihili',
    GLA: 'language.scotch',
    SCO: 'language.scotch',
    COR: 'language.korean',
    KOR: 'language.korean',
    PUN: 'language.punjabi',
    PAN: 'language.punjabi',
    BAQ: 'language.basque',
    ALE: 'language.aleut',
    FRO: 'language.old_french',
    FRS: 'language.farsi',
    YPK: 'language.yupik',
    COP: 'language.coptic',
    DRA: 'language.dravidian',
    SAO: 'language.sao',
    YOR: 'language.yoruba',
    URD: 'language.urdu',
    TIR: 'language.tigrinya',
    THA: 'language.thai',
    TAM: 'language.tamil',
    SWA: 'language.kiswahili',
    SSW: 'language.swazi',
    NAV: 'language.navajo',
    MAR: 'language.marathi',
    MAL: 'language.malayalam',
    MAK: 'language.makassaric',
    KAS: 'language.kashmiri',
    IBO: 'language.igbo',
    HIL: 'language.hiligaynon',
    GUJ: 'language.gujarati',
    ESK: 'language.eskaleut',
    CEB: 'language.cebuano',
    CAT: 'language.catalan',
    YID: 'language.yiddish',
    WEL: 'language.welsh',
    VIE: 'language.vietnamese',
    UKR: 'language.ukrainian',
    TUR: 'language.turkish',
    TIB: 'language.tibetan',
    SIT: 'language.tibetan',
    TEL: 'language.telugu',
    Telugu: 'language.telugu',
    SYR: 'language.arabic',
    SOM: 'language.somalian',
    SEM: 'language.semitic',
    SCR: 'languages.serbocroatian',
    RUS: 'languages.russian',
    POR: 'language.portuguese',
    POL: 'language.polish',
    NOR: 'language.norwegian',
    MAY: 'language.malay',
    LAT: 'language.latin',
    LAO: 'language.lao',
    ITA: 'language.italian',
    IRI: 'language.irish',
    HUN: 'language.hungarian',
    HEB: 'language.hebrew',
    HAW: 'language.hawaiian',
    GRE: 'language.greek',
    GRC: 'language.old_greek',
    GAE: 'language.scottish gaelic',
    GLE: 'language.scottish gaelic',
    FIN: 'language.finnish',
    DAN: 'language.danish',
    CPF: 'language.creole',
    CPE: 'language.creole',
    CHI: 'languages.chinese',
    BUR: 'language.burmese',
    BUL: 'language.bulgarian',
    BEN: 'language.bengali',
    ARC: 'language.aramaic',
    ARA: 'language.arabic',
    AMH: 'language.amharic',
    ALB: 'language.albanian',
    AFR: 'language.afrikaans',
    SPA: 'language.spanish',
    ESP: 'language.spanish',
    SDN: 'language.sardinian',
    TAG: 'language.tagalog',
    ANG: 'language.old_english',
    CAM: 'language.khmer',
    ETH: 'language.ethiopian',
    LIT: 'language.lithuanian',
    EPO: 'language.esperanto',
    MDR: 'language.mandarin',
    ARM: 'language.armenian',
    ALG: 'language.algonkin',
    HAU: 'language.hausa',
    BRL: 'language.braille',
    DAK: 'language.dakota',
    KLI: 'language.klingon',
    APA: 'language.apache',
    ABK: 'language.abkhaz',
    AZE: 'language.azerbaijani',
    BEL: 'language.belarusian',
    BNT: 'language.bantu',
    BOS: 'language.bosnian',
    ELX: 'language.elamite',
    EST: 'language.estonian',
    GSW: 'language.swiss_german',
    IPK: 'language.inupiaq',
    IRO: 'language.iroquoian',
    KIN: 'language.kinyarwanda',
    KUR: 'language.kurdish',
    LTZ: 'language.luxembourgish',
    NQO: 'language.nyankole',
    SOT: 'language.sotho',
    UZB: 'language.uzbek',
    ZUL: 'language.zulu',
    UNK: '', // "Unknown" should not be displayed
};
const getLanguageDisplayString = (languageCode) => {
    if (!languageCode)
        return undefined;
    const languageCodeKey = LanguageCodeMapping[languageCode];
    return languageCodeKey ? __string(languageCodeKey) : undefined;
};
const LanguageDisplay = ({ languageCode }) => {
    const languageDisplayString = getLanguageDisplayString(languageCode);
    if (!languageDisplayString)
        return null;
    return React.createElement(React.Fragment, null,
        __('language') + languageDisplayString,
        " ");
};

const PriceHint = ({ amount }) => (React.createElement("span", { className: "price-hint" },
    "(",
    amount === Money.zero ? __('price.hint.free') : Money.getFormatted(amount),
    ")"));

const BREAK_AMOUNTS = {
    [CSSBreakPoint.XS]: 2,
    [CSSBreakPoint.SM]: 3,
    [CSSBreakPoint.M]: 5,
    [CSSBreakPoint.L]: 5,
};
const RecommendationSlider = ({ headline, items, selectedItemIndex, loadMore, itemsPerSlide, onLoadMore, }) => {
    const defaultItemsPerSlide = useCarouselAmount(BREAK_AMOUNTS);
    itemsPerSlide !== null && itemsPerSlide !== void 0 ? itemsPerSlide : (itemsPerSlide = defaultItemsPerSlide);
    const handleSlideChange = (slideIndex) => {
        if (!loadMore || !onLoadMore || !itemsPerSlide) {
            return;
        }
        const slidesCount = Math.ceil(items.length / itemsPerSlide);
        const lastSlideIdx = slidesCount - 1;
        const penultimateSlideIdx = lastSlideIdx - 1;
        if (slideIndex === penultimateSlideIdx) {
            onLoadMore();
        }
    };
    return (React.createElement("div", { className: `recommendations` },
        headline && React.createElement("h2", null, headline),
        React.createElement(Slider, { className: "article", items: items, itemsPerSlide: itemsPerSlide, selectedItemIndex: selectedItemIndex, reset: false, onSlideChange: handleSlideChange })));
};

const SearchAlternativeArticles = ({ alternativeArticles, title, authorList, onClick, }) => {
    const [showProductAlternatives, setOpenShowProductAlternatives] = useToggle(false);
    const alternativeProductUrls = useMemo(() => alternativeArticles.map(({ alternativeArticleId, alternativeArticleWaarDisplayName }) => LinkUtil.buildArticleDetailPageLink(alternativeArticleId, alternativeArticleWaarDisplayName, title, authorList)), [alternativeArticles, authorList, title]);
    const alternativeFormatText = alternativeArticles && alternativeArticles.length > 1
        ? 'searchArticle.formats.info'
        : 'searchArticle.formats.info.single';
    return (React.createElement("div", { className: "accordion accordion-simple more-product-types", "data-t-search-moreformat": "Weitere Formate" },
        React.createElement("div", { className: _.classNames('acc-head toggle-collapse', showProductAlternatives && 'active'), onClick: setOpenShowProductAlternatives }, __({
            id: alternativeFormatText,
            values: { formatCount: alternativeArticles.length },
        })),
        React.createElement("div", { className: _.classNames('acc-body ', !showProductAlternatives && 'collapse') }, alternativeArticles.map(({ alternativeArticleId, alternativeArticleWaarDisplayName, price }, idx) => (React.createElement("div", { className: "product-type-item", key: alternativeArticleId },
            React.createElement(A, { className: "btn btn-simple btn-icon-left icon-arrow-right", trackId: TRACK_ID('2021-03-26 02:54:49'), href: alternativeProductUrls[idx], onClick: onClick }, alternativeArticleWaarDisplayName),
            price !== undefined && ( // 0 should be rendered as price
            React.createElement("div", { className: "price" }, Money.getFormatted(price)))))))));
};

const ARTICLE_TYPE_COUPON = 'Geschenkkarte';
var ArticleTypeId;
(function (ArticleTypeId) {
    ArticleTypeId[ArticleTypeId["BUCH"] = 1] = "BUCH";
    ArticleTypeId[ArticleTypeId["TASCHENBUCH"] = 2] = "TASCHENBUCH";
    ArticleTypeId[ArticleTypeId["AUDIOCD"] = 3] = "AUDIOCD";
    ArticleTypeId[ArticleTypeId["AUDIOMC"] = 4] = "AUDIOMC";
    ArticleTypeId[ArticleTypeId["AUDIODOWNLOAD"] = 5] = "AUDIODOWNLOAD";
    ArticleTypeId[ArticleTypeId["VIDEODVD"] = 6] = "VIDEODVD";
    ArticleTypeId[ArticleTypeId["VIDEOCASSETTE"] = 7] = "VIDEOCASSETTE";
    ArticleTypeId[ArticleTypeId["SOFTWARE"] = 8] = "SOFTWARE";
    ArticleTypeId[ArticleTypeId["EBOOK"] = 9] = "EBOOK";
    ArticleTypeId[ArticleTypeId["NONBOOK"] = 10] = "NONBOOK";
    ArticleTypeId[ArticleTypeId["ZEITSCHRIFTEN"] = 13] = "ZEITSCHRIFTEN";
    ArticleTypeId[ArticleTypeId["HOERBUCH"] = 14] = "HOERBUCH";
    ArticleTypeId[ArticleTypeId["KALENDER"] = 15] = "KALENDER";
    ArticleTypeId[ArticleTypeId["USED_BUCH"] = 16] = "USED_BUCH";
    ArticleTypeId[ArticleTypeId["SOFTWARE_DOWNLOAD"] = 17] = "SOFTWARE_DOWNLOAD";
    ArticleTypeId[ArticleTypeId["DOWNLOAD_ABO"] = 18] = "DOWNLOAD_ABO";
    ArticleTypeId[ArticleTypeId["HARDWARE"] = 19] = "HARDWARE";
    ArticleTypeId[ArticleTypeId["GIFT_POSTCARD"] = 20] = "GIFT_POSTCARD";
    ArticleTypeId[ArticleTypeId["PAKET"] = 21] = "PAKET";
    ArticleTypeId[ArticleTypeId["GESCHENKKARTE"] = 22] = "GESCHENKKARTE";
    ArticleTypeId[ArticleTypeId["MAENGELEX"] = 23] = "MAENGELEX";
    ArticleTypeId[ArticleTypeId["SPIELWAREN"] = 24] = "SPIELWAREN";
    ArticleTypeId[ArticleTypeId["AUDIO_DVD"] = 25] = "AUDIO_DVD";
    ArticleTypeId[ArticleTypeId["VINYL"] = 26] = "VINYL";
    ArticleTypeId[ArticleTypeId["HOERBUCH_DL"] = 27] = "HOERBUCH_DL";
    ArticleTypeId[ArticleTypeId["BLAETTER_KARTEN"] = 28] = "BLAETTER_KARTEN";
    ArticleTypeId[ArticleTypeId["BUCH_GEBUNDEN"] = 29] = "BUCH_GEBUNDEN";
    ArticleTypeId[ArticleTypeId["BUCH_GEHEFTET"] = 30] = "BUCH_GEHEFTET";
    ArticleTypeId[ArticleTypeId["BUCH_KARTONIERT"] = 31] = "BUCH_KARTONIERT";
    ArticleTypeId[ArticleTypeId["BUCH_LEDEREINBAND"] = 32] = "BUCH_LEDEREINBAND";
    ArticleTypeId[ArticleTypeId["BUCH_LEINENEINBAND"] = 33] = "BUCH_LEINENEINBAND";
    ArticleTypeId[ArticleTypeId["EBOOK_PDF"] = 34] = "EBOOK_PDF";
    ArticleTypeId[ArticleTypeId["HOERBUCH_CD"] = 35] = "HOERBUCH_CD";
    ArticleTypeId[ArticleTypeId["HOERBUCH_DVD"] = 36] = "HOERBUCH_DVD";
    ArticleTypeId[ArticleTypeId["HOERBUCH_KASSETTE"] = 37] = "HOERBUCH_KASSETTE";
    ArticleTypeId[ArticleTypeId["HOERBUCH_VINYL"] = 38] = "HOERBUCH_VINYL";
    ArticleTypeId[ArticleTypeId["BLURAY"] = 39] = "BLURAY";
    ArticleTypeId[ArticleTypeId["GESCHENKKARTEDOWNLOAD"] = 40] = "GESCHENKKARTEDOWNLOAD";
})(ArticleTypeId || (ArticleTypeId = {}));
const parse$h = (json) => ({
    id: Type.number(json.id, 'ProductType.id'),
    name: Type.string(json.name, 'ProductType.name'),
    displayName: Type.optional.string(json.displayName, 'ProductType.displayName'),
    noPickUpGood: Type.boolean(json.noPickUpGood, 'ProductType.noPickUpGood'),
});
const WsArticleType = { parse: parse$h };

const getProductTypeIcon = (typeId, color = 'black') => {
    const colorClassAdd = color ? '-' + color : '';
    switch (typeId) {
        case ArticleTypeId.AUDIODOWNLOAD:
            return 'icon-audiobookDownload' + colorClassAdd;
        case ArticleTypeId.AUDIOMC:
            return 'icon-cassette' + colorClassAdd;
        case ArticleTypeId.BUCH:
            return 'icon-books' + colorClassAdd;
        case ArticleTypeId.TASCHENBUCH:
            return 'icon-books' + colorClassAdd;
        case ArticleTypeId.BUCH_GEBUNDEN:
            return 'icon-books' + colorClassAdd;
        case ArticleTypeId.BUCH_GEHEFTET:
            return 'icon-books' + colorClassAdd;
        case ArticleTypeId.BUCH_KARTONIERT:
            return 'icon-books' + colorClassAdd;
        case ArticleTypeId.BUCH_LEDEREINBAND:
            return 'icon-books' + colorClassAdd;
        case ArticleTypeId.BUCH_LEINENEINBAND:
            return 'icon-books' + colorClassAdd;
        case ArticleTypeId.MAENGELEX:
            return 'icon-books' + colorClassAdd;
        case ArticleTypeId.HOERBUCH:
            return 'icon-audiobook' + colorClassAdd;
        case ArticleTypeId.HOERBUCH_DVD:
            return 'icon-audiobook' + colorClassAdd;
        case ArticleTypeId.HOERBUCH_CD:
            return 'icon-audiobook' + colorClassAdd;
        case ArticleTypeId.HOERBUCH_KASSETTE:
            return 'icon-audiobook' + colorClassAdd;
        case ArticleTypeId.HOERBUCH_VINYL:
            return 'icon-audiobook' + colorClassAdd;
        case ArticleTypeId.HOERBUCH_DL:
            return 'icon-audiobookDownload' + colorClassAdd;
        case ArticleTypeId.SPIELWAREN:
            return 'icon-toy' + colorClassAdd;
        case ArticleTypeId.VINYL:
            return 'icon-vinyl' + colorClassAdd;
        case ArticleTypeId.AUDIOCD:
            return 'icon-cd' + colorClassAdd;
        case ArticleTypeId.AUDIO_DVD:
            return 'icon-cd' + colorClassAdd;
        case ArticleTypeId.VIDEODVD:
            return 'icon-cd' + colorClassAdd;
        case ArticleTypeId.BLURAY:
            return 'icon-cd' + colorClassAdd;
        case ArticleTypeId.VIDEOCASSETTE:
            return 'icon-cd' + colorClassAdd;
        case ArticleTypeId.SOFTWARE:
            return 'icon-cd' + colorClassAdd;
        case ArticleTypeId.SOFTWARE_DOWNLOAD:
            return 'icon-app' + colorClassAdd;
        case ArticleTypeId.DOWNLOAD_ABO:
            return 'icon-app' + colorClassAdd;
        case ArticleTypeId.HARDWARE:
            return 'icon-tablet' + colorClassAdd;
        case ArticleTypeId.EBOOK:
            return 'icon-ebook' + colorClassAdd;
        case ArticleTypeId.EBOOK_PDF:
            return 'icon-ebook' + colorClassAdd;
        case ArticleTypeId.KALENDER:
            return 'icon-calendar' + colorClassAdd;
        case ArticleTypeId.GESCHENKKARTE:
            return 'icon-gift' + colorClassAdd;
        case ArticleTypeId.GIFT_POSTCARD:
            return 'icon-gift' + colorClassAdd;
        case ArticleTypeId.BLAETTER_KARTEN:
            return 'icon-images' + colorClassAdd;
        case ArticleTypeId.GESCHENKKARTEDOWNLOAD:
            return 'icon-gift' + colorClassAdd;
        default:
            return 'icon-otherArticle' + colorClassAdd;
    }
};
var ProductIdReverseMapping;
(function (ProductIdReverseMapping) {
    ProductIdReverseMapping[ProductIdReverseMapping["Buch"] = 1] = "Buch";
    ProductIdReverseMapping[ProductIdReverseMapping["Taschenbuch"] = 2] = "Taschenbuch";
    ProductIdReverseMapping[ProductIdReverseMapping["CD"] = 3] = "CD";
    ProductIdReverseMapping[ProductIdReverseMapping["Kassette"] = 4] = "Kassette";
    ProductIdReverseMapping[ProductIdReverseMapping["Audio Download"] = 5] = "Audio Download";
    ProductIdReverseMapping[ProductIdReverseMapping["DVD"] = 6] = "DVD";
    ProductIdReverseMapping[ProductIdReverseMapping["VHS"] = 7] = "VHS";
    ProductIdReverseMapping[ProductIdReverseMapping["Software"] = 8] = "Software";
    ProductIdReverseMapping[ProductIdReverseMapping["eBook epub"] = 9] = "eBook epub";
    ProductIdReverseMapping[ProductIdReverseMapping["Sonstiger Artikel"] = 10] = "Sonstiger Artikel";
    ProductIdReverseMapping[ProductIdReverseMapping["Zeitschrift"] = 13] = "Zeitschrift";
    ProductIdReverseMapping[ProductIdReverseMapping["H\u00F6rbuch"] = 14] = "H\u00F6rbuch";
    ProductIdReverseMapping[ProductIdReverseMapping["Kalender"] = 15] = "Kalender";
    ProductIdReverseMapping[ProductIdReverseMapping["Gebrauchter Artikel"] = 16] = "Gebrauchter Artikel";
    ProductIdReverseMapping[ProductIdReverseMapping["App"] = 17] = "App";
    ProductIdReverseMapping[ProductIdReverseMapping["Download-Abonnement"] = 18] = "Download-Abonnement";
    ProductIdReverseMapping[ProductIdReverseMapping["Hardware"] = 19] = "Hardware";
    ProductIdReverseMapping[ProductIdReverseMapping["Geschenk-Postkarte"] = 20] = "Geschenk-Postkarte";
    ProductIdReverseMapping[ProductIdReverseMapping["Paket"] = 21] = "Paket";
    ProductIdReverseMapping[ProductIdReverseMapping["Geschenkkarte"] = 22] = "Geschenkkarte";
    ProductIdReverseMapping[ProductIdReverseMapping["M\u00E4ngelexemplar"] = 23] = "M\u00E4ngelexemplar";
    ProductIdReverseMapping[ProductIdReverseMapping["Spielware"] = 24] = "Spielware";
    ProductIdReverseMapping[ProductIdReverseMapping["Audio DVD"] = 25] = "Audio DVD";
    ProductIdReverseMapping[ProductIdReverseMapping["Vinyl"] = 26] = "Vinyl";
    ProductIdReverseMapping[ProductIdReverseMapping["H\u00F6rbuch Download"] = 27] = "H\u00F6rbuch Download";
    ProductIdReverseMapping[ProductIdReverseMapping["Bl\u00E4tter und Karten"] = 28] = "Bl\u00E4tter und Karten";
    ProductIdReverseMapping[ProductIdReverseMapping["Buch (gebunden)"] = 29] = "Buch (gebunden)";
    ProductIdReverseMapping[ProductIdReverseMapping["Buch (geheftet)"] = 30] = "Buch (geheftet)";
    ProductIdReverseMapping[ProductIdReverseMapping["Buch (kartoniert)"] = 31] = "Buch (kartoniert)";
    ProductIdReverseMapping[ProductIdReverseMapping["Buch (Ledereinband)"] = 32] = "Buch (Ledereinband)";
    ProductIdReverseMapping[ProductIdReverseMapping["Buch (Leineneinband)"] = 33] = "Buch (Leineneinband)";
    ProductIdReverseMapping[ProductIdReverseMapping["eBook pdf"] = 34] = "eBook pdf";
    ProductIdReverseMapping[ProductIdReverseMapping["H\u00F6rbuch CD"] = 35] = "H\u00F6rbuch CD";
    ProductIdReverseMapping[ProductIdReverseMapping["H\u00F6rbuch DVD"] = 36] = "H\u00F6rbuch DVD";
    ProductIdReverseMapping[ProductIdReverseMapping["H\u00F6rbuch Kassette"] = 37] = "H\u00F6rbuch Kassette";
    ProductIdReverseMapping[ProductIdReverseMapping["H\u00F6rbuch Vinyl"] = 38] = "H\u00F6rbuch Vinyl";
    ProductIdReverseMapping[ProductIdReverseMapping["Blu-ray"] = 39] = "Blu-ray";
    ProductIdReverseMapping[ProductIdReverseMapping["Geschenkgutschein"] = 40] = "Geschenkgutschein";
})(ProductIdReverseMapping || (ProductIdReverseMapping = {}));
const ProductIconTools = { getProductTypeIcon, ProductIdReverseMapping };

const SearchArticleRating = ({ reviewVotes, reviewAvg }) => {
    if (!reviewVotes || reviewAvg === undefined) {
        return null;
    }
    const rating = calculateRatingFromPercent(reviewAvg);
    return (React.createElement("div", { className: "rating-summary" },
        React.createElement(ReviewStars, { rating: rating }),
        React.createElement("div", { className: "ratings" },
            "(",
            React.createElement("span", { className: "rating-value" }, reviewVotes),
            React.createElement("span", { className: "ratings-label" }, reviewVotes === 1
                ? __('searchArticle.ratings.label.single')
                : __('searchArticle.ratings.label.multi')),
            ")",
            React.createElement("span", { className: "footnote-ref" }, "15"))));
};

const SearchArticleItemDetails = ({ title, subtitle, authorList, productUrl, availabilityData, productTypeDisplayName, productTypeId, price, oldPrice, priceLabel, oldPriceLabel, rebateCategory, publicationDate, languageCode, reviewAvg, reviewVotes, onClick, }) => {
    const fullTitle = [title, subtitle].filter(Boolean).join(': ');
    const now = new Date();
    const parsedPublicationDate = publicationDate ? new Date(publicationDate) : undefined;
    const publicationDateIsInTheFuture = parsedPublicationDate && parsedPublicationDate > now;
    // this overwrite is based on: hardcoded number 0 for LIEB_NR 0 "Auf Lager"
    const overwritePublicationDate = availabilityData.number.valueOf() === 0 && publicationDateIsInTheFuture;
    const publicationDateLabel = overwritePublicationDate
        ? 'searchArticle.publicationDate.label.empty'
        : 'searchArticle.publicationDate.label';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "col col-xs-12 col-sm-8" },
            React.createElement("div", { className: "primary-item-info" },
                React.createElement(A, { trackId: TRACK_ID('2019-09-02 11:32:27'), href: productUrl, className: "title", onClick: onClick },
                    React.createElement(ArticleTitle, { title: fullTitle })),
                authorList && React.createElement(ArticleAuthors, { authors: authorList, shouldRedirectToAdvancedSearch: true })),
            React.createElement("div", { className: "secondary-item-info" },
                React.createElement(SearchArticleRating, { reviewVotes: reviewVotes, reviewAvg: reviewAvg }),
                React.createElement("div", { className: _.classNames('item-type ', ProductIconTools.getProductTypeIcon(productTypeId)) }, productTypeDisplayName),
                React.createElement(LanguageDisplay, { languageCode: languageCode }),
                React.createElement(ArticleAvailability, { availabilityData: availabilityData, publicationDate: overwritePublicationDate ? undefined : parsedPublicationDate, preOrderMessage: __string(publicationDateLabel) }))),
        price !== undefined && (React.createElement("div", { className: "item-price col col-xs-12 col-sm-4" }, oldPrice && oldPrice > price ? (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "price-info" }, productTypeId === ArticleTypeId.MAENGELEX ? (React.createElement(React.Fragment, null,
                __({
                    id: 'searchArticle.details.discount.defective.info',
                    values: { productTypeDisplayName },
                }),
                rebateCategory !== 0 && React.createElement("span", { className: "footnote-ref" }, rebateCategory))) : (React.createElement(React.Fragment, null,
                priceLabel,
                rebateCategory !== 0 && React.createElement("span", { className: "footnote-ref" }, rebateCategory)))),
            React.createElement("span", { className: "price price-reduced" },
                Money.getFormatted(price),
                React.createElement("span", { className: "footnote-ref" }, "*")),
            React.createElement("span", { className: "price price-old" },
                oldPriceLabel + ' ',
                Money.getFormatted(oldPrice),
                rebateCategory !== 0 && React.createElement("span", { className: "footnote-ref" }, rebateCategory)))) : (React.createElement("span", { className: "price price-default" },
            Money.getFormatted(price),
            React.createElement("span", { className: "footnote-ref" }, "*")))))));
};

const SearchArticleItem = ({ article, articleSource, onGoToProductPage, itemCallbackRef, }) => {
    // TODO this is not working in test
    const [submitting, onClickAddToBasket] = useProgressCallback(() => BasketModals.addToBasket(article, { index: 0, rating: 0, source: articleSource }));
    const { id, articleAttributeView, articlePrices, rebateCategory, productType, alternativeArticles, availabilityData, reviewAvg, reviewVotes, } = article;
    const { authorList, imgExtraLarge, title, subtitle, languageCode } = articleAttributeView;
    const [priceObj] = articlePrices;
    const { price, oldPrice, priceLabel, oldPriceLabel } = priceObj;
    const productTypeDisplayName = productType === null || productType === void 0 ? void 0 : productType.displayName;
    const productTypeId = productType === null || productType === void 0 ? void 0 : productType.id;
    const resizedCover = imgExtraLarge && imgExtraLarge + '?width=150';
    const productUrl = useArticleDetailsLink(id, productTypeDisplayName, title, authorList);
    const now = new Date();
    const publicationDateIsInTheFuture = (articleAttributeView === null || articleAttributeView === void 0 ? void 0 : articleAttributeView.publicationDate) && new Date(articleAttributeView.publicationDate) > now;
    const overwriteBasketLabel = availabilityData.number === 0 && publicationDateIsInTheFuture;
    const basketLabel = publicationDateIsInTheFuture ? 'searchArticle.btn.pre.order' : 'searchArticle.btn.add.to.cart';
    const finalBasketLabel = overwriteBasketLabel ? 'searchArticle.btn.add.to.cart' : basketLabel;
    return (React.createElement("div", { ref: itemCallbackRef, className: "search-item article-item" },
        React.createElement("div", { className: "cover-col" },
            React.createElement(A, { href: productUrl, onClick: onGoToProductPage, trackId: TRACK_ID('2020-11-02 11:32:27') },
                React.createElement(CoverImg, { coverPath: resizedCover, title: title, price: price, oldPrice: oldPrice, rebateCategory: rebateCategory }))),
        React.createElement("div", { className: "details-col" },
            React.createElement("div", { className: "row" },
                React.createElement(SearchArticleItemDetails, { title: title, subtitle: subtitle, authorList: authorList, productUrl: productUrl, productTypeDisplayName: productTypeDisplayName, availabilityData: availabilityData, productTypeId: productTypeId, price: price, oldPrice: oldPrice, priceLabel: priceLabel, oldPriceLabel: oldPriceLabel, rebateCategory: rebateCategory, publicationDate: articleAttributeView === null || articleAttributeView === void 0 ? void 0 : articleAttributeView.publicationDate, languageCode: languageCode, reviewAvg: reviewAvg, reviewVotes: reviewVotes, onClick: onGoToProductPage }),
                React.createElement("div", { className: "col col-xs-12 col-sm-6 col-sm-push-6 right", "data-t-search-addtocart": "In den Warenkorb" },
                    React.createElement(Button, { className: _.classNames('btn btn-sm btn-primary btn-add-to-basket'), label: finalBasketLabel, onClick: onClickAddToBasket, loading: submitting },
                        React.createElement("span", { className: "icon icon-cart-white" }))),
                React.createElement("div", { className: "col col-xs-12 col-sm-6 col-sm-pull-6" }, alternativeArticles && alternativeArticles.length > 0 && (React.createElement(SearchAlternativeArticles, { alternativeArticles: alternativeArticles, title: title, authorList: authorList, onClick: onGoToProductPage })))))));
};

const createArticleAttributeView = (overrides) => ({
    allowedCountries: undefined,
    articleGroupNumber: undefined,
    articleId: undefined,
    assistantList: undefined,
    audioLibriNumber: undefined,
    authorList: undefined,
    binderName: undefined,
    bzNumber: undefined,
    displayPublicationDate: undefined,
    ean: undefined,
    editorList: undefined,
    epubFamilySharingUsageLimit: undefined,
    imgExtraLarge: undefined,
    imgExtraLargeHeight: undefined,
    imgExtraLargeWidth: undefined,
    imgLarge: undefined,
    imgLargeHeight: undefined,
    imgLargeWidth: undefined,
    imgMedium: undefined,
    imgMediumHeight: undefined,
    imgMediumWidth: undefined,
    imgSmall: undefined,
    imgSmallHeight: undefined,
    imgSmallWidth: undefined,
    isbnWithSeparators: undefined,
    libriDigitalNumber: undefined,
    libriNumber: undefined,
    mobipocketNumber: undefined,
    orisNumber: undefined,
    pages: undefined,
    productLineId: undefined,
    productLineName: undefined,
    publicationDate: undefined,
    publisherName: undefined,
    serieNr: undefined,
    serieSort: undefined,
    serieText: undefined,
    shortSubtitle: undefined,
    subtitle: undefined,
    title: undefined,
    translatorList: undefined,
    languageCode: undefined,
    ...overrides,
});
const WsArticleAttributeBuilder = { createArticleAttributeView };

const createArticlePrice = (overrides) => ({
    bonusCost: 0,
    catalogId: 1234,
    customerGroupId: 567890,
    freeOfShippingCosts: false,
    oldPrice: undefined,
    oldPriceLabel: 'oldPriceLabel',
    price: Money.parse(4242),
    priceLabel: 'priceLabel',
    ...overrides,
});
const createArticlePrices = (overrides) => [
    createArticlePrice(overrides),
    createArticlePrice(),
];
const WsArticlePriceBuilder = { createArticlePrice, createArticlePrices };

const createArticleType = (overrides) => ({
    id: 774763492,
    name: 'Test Name',
    displayName: 'Test Display Name',
    noPickUpGood: true,
    ...overrides,
});
const WsArticleTypeBuilder = { createArticleType };

const createArticle = (overrides) => ({
    active: true,
    alsoAvailableDummyArticleId: 0,
    alsoAvailableInBundleId: 0,
    alternativeArticles: [],
    articleAnnotations: [],
    articleAttributeView: WsArticleAttributeBuilder.createArticleAttributeView({
        allowedCountries: '',
        articleGroupNumber: '',
        articleId: 35062264,
        assistantList: '',
        audioLibriNumber: '',
        authorList: '',
        binderName: 'Kalender',
        bzNumber: '',
        displayPublicationDate: 'November 2018',
        ean: '9783946688617',
        editorList: '',
        epubFamilySharingUsageLimit: 0,
        imgExtraLarge: '350/35062264_9783946688617_xl.jpg',
        imgExtraLargeHeight: 1020,
        imgExtraLargeWidth: 828,
        imgLarge: '350/35062264_9783946688617_big.jpg',
        imgLargeHeight: 0,
        imgLargeWidth: 0,
        imgMedium: '350/35062264_9783946688617_middle.jpg',
        imgMediumHeight: 0,
        imgMediumWidth: 0,
        imgSmall: '350/35062264_9783946688617_small.jpg',
        imgSmallHeight: 85,
        imgSmallWidth: 69,
        isbnWithSeparators: '3946688616',
        libriDigitalNumber: '',
        libriNumber: '',
        mobipocketNumber: '',
        orisNumber: '',
        pages: '370',
        productLineId: 1,
        productLineName: '',
        publicationDate: new Date('2019-10-01 02:00:00'),
        publisherName: 'Seltmann + Söhne',
        serieNr: '5',
        serieSort: 5,
        serieText: 'Notes of Berlin',
        shortSubtitle: '',
        subtitle: '',
        title: 'Notes of Berlin 2020',
        translatorList: '',
    }),
    articlePrices: WsArticlePriceBuilder.createArticlePrices({
        bonusCost: 0,
        catalogId: 0,
        customerGroupId: 40,
        freeOfShippingCosts: false,
        oldPrice: Money.parse(0),
        oldPriceLabel: '',
        price: Money.parse(2480),
        priceLabel: '',
    }),
    availableForOneClick: false,
    binderTypeId: 4537,
    bundleId: 0,
    clientArticle: undefined,
    combinedProduct: undefined,
    commodityGroup: undefined,
    deliveryBookspressBookshop: false,
    deliveryDownload: false,
    deliveryShipmentBookshop: false,
    deliveryShipmentDirect: true,
    digitalArticleAttributes: [],
    externalArticle: false,
    externalButtonText: '',
    externalCssClassName: '',
    externalHintLayer: '',
    externalHintText: '',
    externalLogoUrl: '',
    externalMobileProductPageUrl: '',
    externalOpenNewWindow: false,
    externalProductPageUrl: '',
    externalProviderName: '',
    externalShowHintLayer: false,
    fixedPrice: true,
    id: 35062264,
    keywords: [],
    lastAlternativeArticlesUpdate: undefined,
    modificationDate: undefined,
    noPickUpGood: false,
    notAvailableAsAGift: true,
    people: [],
    productType: WsArticleTypeBuilder.createArticleType({
        displayName: 'Kalender',
        id: 15,
        name: 'Kalender',
        noPickUpGood: false,
    }),
    publisherId: 0,
    rebateCategory: undefined,
    rebateDescription: '',
    restrictedToBundle: false,
    reviewAvg: -1,
    reviewVotes: -1,
    reviews: [],
    searchableClientId: 0,
    spiegelProduct: false,
    subscription: false,
    subscriptionThatOffersArticle: undefined,
    availabilityData: {
        number: -1,
        text: 'Verfügbarkeit unbekannt',
        currentlyAvailable: false,
        preorder: false,
    },
    ...overrides,
});
const createArticles = (overrides) => [createArticle(overrides), createArticle()];
const WsArticleBuilder = { createArticle, createArticles };

const createDigitalArticle = (overrides) => {
    const defaultItem = {
        articleId: 28952428,
        deliveryStatus: DeliveryStatus.PENDING,
        downloadId: '34948164bb9106113959f4f814facada',
        downloadAllowed: true,
        ePublishingUrl: 'epublishing://openbook?deliverableid=DT5000.9783641207786',
        tolinoWebreaderUrl: 'https://webreader.prodref.mytolino.com/library/index.html?reseller=13&autologin=true#/epub?id=DT5000.9783641207786',
        downloadType: DownloadType.EPUB,
    };
    return { ...defaultItem, ...overrides };
};
const createDigitalArticles = (statusList = [DeliveryStatus.PENDING, DeliveryStatus.PENDING]) => statusList.map((status, index) => createDigitalArticle({ articleId: index + 1, deliveryStatus: status }));
const WsDigitalArticleBuilder = { createDigitalArticle, createDigitalArticles };

var WishlistItemStatus;
(function (WishlistItemStatus) {
    WishlistItemStatus["OPEN"] = "OPEN";
    WishlistItemStatus["BOUGHT"] = "BOUGHT";
})(WishlistItemStatus || (WishlistItemStatus = {}));
const parseWishlistItemStatus = EnumUtil.parser({
    enumValues: WishlistItemStatus,
    enumTypeName: 'WishlistItemStatus',
});
const parseOldPrice = (oldPrice) => {
    const parsedOldPrice = Type.falsyToUndefined.number(oldPrice, 'WishlistItem.oldPrice');
    return parsedOldPrice ? Money.parse(parsedOldPrice) : undefined;
};
const parse$g = (obj) => ({
    id: Type.number(obj.id, 'WishlistItem.id'),
    wishlistId: Type.string(obj.wishlistId, 'WishlistItem.wishlistId'),
    lastOrderDate: Type.optional.dateString(obj.lastOrderDate, 'WishlistItem.lastOrderDate'),
    status: parseWishlistItemStatus(obj.status),
    addToListDate: Type.dateString(obj.addToListDate, 'WishlistItem.addToListDate'),
    articleId: Type.number(obj.articleId, 'WishlistItem.articleId'),
    coverUrlLarge: Type.optional.string(obj.coverUrlLarge, 'WishlistItem.coverUrlLarge'),
    price: Money.parse(Type.number(obj.price, 'WishlistItem.price')),
    priceLabel: Type.falsyToUndefined.string(obj.priceLabel, 'WishlistItem.priceLabel'),
    oldPrice: parseOldPrice(obj.oldPrice),
    oldPriceLabel: Type.falsyToUndefined.string(obj.oldPriceLabel, 'WishlistItem.oldPriceLabel'),
    rebateCategory: Type.falsyToUndefined.number(obj.rebateCategory, 'WishlistItem.rebateCategory'),
    rebateDescription: Type.falsyToUndefined.string(obj.rebateDescription, 'WishlistItem.rebateDescription'),
    productType: WsArticleType.parse(Type.object(obj.productType, 'WishlistItem.productType')),
    authors: Type.optional.string(obj.authors, 'WishlistItem.authors'),
    title: Type.string(obj.title, 'WishlistItem.title'),
    availabilityData: WsAvailabilityData.parse(obj.availabilityData),
    publicationDate: Type.optional.dateString(obj.publicationDate, 'WishlistItem.publicationDate'),
});
const WsWishlistItem = { parse: parse$g };

const createWishlistItem = (overrides) => ({
    id: 1,
    wishlistId: '774763492',
    lastOrderDate: undefined,
    status: WishlistItemStatus.OPEN,
    articleId: 23698867,
    authors: 'Harry Rowohlt, David Sedaris, David Lodge',
    coverUrlLarge: '236/23698867_23698867_big.jpg',
    price: Money.parse(699),
    priceLabel: undefined,
    oldPrice: undefined,
    oldPriceLabel: undefined,
    rebateCategory: undefined,
    rebateDescription: undefined,
    productType: {
        id: 5,
        name: 'Audio-Download',
        displayName: 'Hörbuch Download',
        noPickUpGood: true,
    },
    title: 'The Best of Harry Rowohlt',
    availabilityData: {
        number: 5,
        text: 'Sofort lieferbar (Download)',
        currentlyAvailable: true,
        preorder: false,
    },
    addToListDate: new Date(2019, 11, 11),
    publicationDate: new Date(2021, 3, 19),
    ...overrides,
});
var JSONDataScope;
(function (JSONDataScope) {
    JSONDataScope["MINIMAL"] = "minimal";
    JSONDataScope["REAL"] = "real";
    JSONDataScope["MAXIMAL"] = "maximal";
})(JSONDataScope || (JSONDataScope = {}));
const createWishlistItemJSON = (jsonDataScope) => {
    switch (jsonDataScope) {
        case JSONDataScope.MINIMAL:
            return {
                id: 6,
                wishlistId: '11476',
                lastOrderDate: undefined,
                status: 'OPEN',
                articleId: 36805350,
                authors: 'Ethan Cross',
                coverUrlLarge: '/368/36805350_9783404179091_xl.jpg',
                price: 1290,
                productType: {
                    id: 8,
                    name: 'Taschenbuch',
                    displayName: 'Taschenbuch',
                    noPickUpGood: false,
                },
                title: 'Die Stimme des Zorns',
                availabilityData: {
                    number: 0,
                    text: 'Sofort lieferbar',
                    currentlyAvailable: true,
                    preorder: false,
                },
                addToListDate: '2020-08-14 00:00:00',
                publicationDate: '2021-04-19 00:00:00',
            };
        case JSONDataScope.REAL:
            return {
                id: 1,
                wishlistId: '774763492',
                lastOrderDate: undefined,
                status: 'OPEN',
                articleId: 23698867,
                authors: 'Harry Rowohlt, David Sedaris, David Lodge',
                coverUrlLarge: '236/23698867_23698867_big.jpg',
                price: 699,
                productType: {
                    id: 5,
                    name: 'Audio-Download',
                    displayName: 'Hörbuch Download',
                    noPickUpGood: true,
                },
                title: 'The Best of Harry Rowohlt',
                availabilityData: {
                    number: 5,
                    text: 'Sofort lieferbar (Download)',
                    currentlyAvailable: true,
                    preorder: false,
                },
                addToListDate: '2020-08-14 00:00:00',
                publicationDate: '2021-04-19 00:00:00',
            };
        case JSONDataScope.MAXIMAL:
            return {
                id: 7,
                wishlistId: '11476349234',
                lastOrderDate: '2020-11-03 00:00:00',
                status: 'BOUGHT',
                articleId: 36574350,
                authors: 'Maria Dries',
                coverUrlLarge: '365/36574350_9783841218216_xl.jpg',
                price: 799,
                priceLabel: 'Als Mängelexemplar',
                oldPrice: 899,
                oldPriceLabel: 'Statt',
                rebateCategory: 1,
                rebateDescription: 'Vergleich zum gebundenden Ladenpreis',
                productType: {
                    id: 7,
                    name: 'Buch (gebunden)',
                    displayName: 'Buch (gebunden)',
                    noPickUpGood: false,
                },
                title: 'Der Kommissar und die Tote von Saint-Georges',
                availabilityData: {
                    number: 12,
                    text: 'Lieferbar innerhalb 2 Wochen',
                    currentlyAvailable: false,
                    preorder: false,
                },
                addToListDate: '2020-11-01 00:00:00',
                publicationDate: '2021-04-19 00:00:00',
            };
    }
};
const WsWishlistItemBuilder = { createWishlistItem, createWishlistItemJSON };

const parse$f = (json) => ({
    alternativeArticleId: Type.number(json.alternativeArticleId, 'AlternativeArticle.alternativeArticleId'),
    alternativeArticleNumber: Type.string(json.alternativeArticleNumber, 'AlternativeArticle.alternativeArticleNumber'),
    alternativeArticleWaarDisplayName: Type.optional.string(json.alternativeArticleWaarDisplayName, 'AlternativeArticle.alternativeArticleWaarDisplayName'),
    alternativeArticleWaarId: Type.optional.number(json.alternativeArticleWaarId, 'AlternativeArticle.alternativeArticleWaarId'),
    articleId: Type.number(json.articleId, 'AlternativeArticle.articleId'),
    automaticallyCreated: Type.optional.boolean(json.automaticallyCreated, 'AlternativeArticle.automaticallyCreated'),
    clientId: Type.number(json.clientId, 'AlternativeArticle.clientId'),
    excludeAlternative: Type.optional.boolean(json.excludeAlternative, 'AlternativeArticle.excludeAlternative'),
    price: Type.optional.number(json.price, 'AlternativeArticle.price'),
});
const WsAlternativeArticle = { parse: parse$f };

const parse$e = (json) => ({
    id: Type.number(json.id, 'AnnotationType.id'),
    code: Type.string(json.code, 'AnnotationType.code'),
    name: Type.optional.string(json.name, 'AnnotationType.name'),
    displayOrder: Type.optional.number(json.displayOrder, 'AnnotationType.displayOrder'),
    manageable: Type.boolean(json.manageable, 'AnnotationType.manageable'),
    modifiedBy: Type.optional.string(json.modifiedBy, 'AnnotationType.modifiedBy'),
    modificationDate: Type.optional.dateString(json.modificationDate, 'AnnotationType.modificationDate'),
    comment: Type.optional.string(json.comment, 'AnnotationType.comment'),
});
const WsAnnotationType = { parse: parse$e };

const _parseAnnotationType = (annotationType) => annotationType ? WsAnnotationType.parse(Type.object(annotationType, 'Annotation.annotationType')) : undefined;
const parse$d = (json) => ({
    id: Type.optional.number(json.id, 'Annotation.id'),
    articleId: Type.number(json.articleId, 'Annotation.articleId'),
    text: Type.optional.string(json.text, 'Annotation.text'),
    modifiedBy: Type.optional.string(json.modifiedBy, 'Annotation.modifiedBy'),
    modificationDate: Type.optional.dateString(json.modificationDate, 'Annotation.modificationDate'),
    modifiedManually: Type.boolean(json.modifiedManually, 'Annotation.modifiedManually'),
    comment: Type.optional.string(json.comment, 'Annotation.comment'),
    annotationTypeId: Type.optional.number(json.annotationTypeId, 'Annotation.annotationTypeId'),
    isWikiTextAvailable: Type.optional.boolean(json.isWikiTextAvailable, 'Annotation.isWikiTextAvailable'),
    source: Type.optional.string(json.source, 'Annotation.source'),
    sourceDate: Type.optional.dateString(json.sourceDate, 'Annotation.sourceDate'),
    annotationType: _parseAnnotationType(json.annotationType),
    sortOrder: Type.optional.number(json.sortOrder, 'Annotation.sortOrder'),
});
const WsAnnotation = { parse: parse$d };

const parse$c = (json) => {
    const oldPriceNumericValue = Type.optional.number(json.oldPrice, 'ArticlePrice.oldPrice');
    return {
        bonusCost: Type.optional.number(json.bonusCost, 'ArticlePrice.bonusCost'),
        catalogId: Type.optional.number(json.catalogId, 'ArticlePrice.catalogId'),
        customerGroupId: Type.optional.number(json.customerGroupId, 'ArticlePrice.customerGroupId'),
        freeOfShippingCosts: Type.boolean(json.freeOfShippingCosts, 'ArticlePrice.freeOfShippingCosts'),
        oldPrice: oldPriceNumericValue ? Money.parse(oldPriceNumericValue) : undefined,
        oldPriceLabel: Type.optional.string(json.oldPriceLabel, 'ArticlePrice.oldPriceLabel'),
        price: Money.parse(Type.number(json.price, 'ArticlePrice.price')),
        priceLabel: Type.optional.string(json.priceLabel, 'ArticlePrice.priceLabel'),
    };
};
const WsArticlePrice = { parse: parse$c };

const parse$b = (json) => ({
    articleId: Type.optional.number(json.articleId, 'ClientArticle.articleId'),
    availabilityId: Type.optional.number(json.availabilityId, 'ClientArticle.availabilityId'),
    availabilityMsg: Type.optional.string(json.availabilityMsg, 'ClientArticle.availabilityMsg'),
    availabilityNumber: Type.optional.number(json.availabilityNumber, 'ClientArticle.availabilityNumber'),
    clientId: Type.optional.number(json.clientId, 'ClientArticle.clientId'),
    notice: Type.optional.string(json.notice, 'ClientArticle.notice'),
    promoPoints: Type.optional.number(json.promoPoints, 'ClientArticle.promoPoints'),
    promoPointsValidTill: Type.optional.dateString(json.promoPointsValidTill, 'ClientArticle.promoPointsValidTill'),
    vat: Type.optional.number(json.vat, 'ClientArticle.vat'),
    dateOfDeliveryMin: Type.optional.dateString(json.dateOfDeliveryMin, 'ClientArticle.dateOfDeliveryMin'),
    dateOfDeliveryMax: Type.optional.dateString(json.dateOfDeliveryMax, 'ClientArticle.dateOfDeliveryMax'),
    daysDelay: Type.optional.number(json.daysDelay, 'ClientArticle.daysDelay'),
});
const WsClientArticle = { parse: parse$b };

const parse$a = (json) => ({
    allowedCountries: Type.optional.string(json.allowedCountries, 'ArticleAttributeView.allowedCountries'),
    articleGroupNumber: Type.optional.string(json.articleGroupNumber, 'ArticleAttributeView.articleGroupNumber'),
    articleId: Type.optional.number(json.articleId, 'ArticleAttributeView.articleId'),
    assistantList: Type.optional.string(json.assistantList, 'ArticleAttributeView.assistantList'),
    audioLibriNumber: Type.optional.string(json.audioLibriNumber, 'ArticleAttributeView.audioLibriNumber'),
    authorList: Type.optional.string(json.authorList, 'ArticleAttributeView.authorList'),
    binderName: Type.optional.string(json.binderName, 'ArticleAttributeView.binderName'),
    bzNumber: Type.optional.string(json.bzNumber, 'ArticleAttributeView.bzNumber'),
    displayPublicationDate: Type.optional.string(json.displayPublicationDate, 'ArticleAttributeView.displayPublicationDate'),
    ean: Type.optional.string(json.ean, 'ArticleAttributeView.ean'),
    editorList: Type.optional.string(json.editorList, 'ArticleAttributeView.editorList'),
    epubFamilySharingUsageLimit: Type.optional.number(json.epubFamilySharingUsageLimit, 'ArticleAttributeView.epubFamilySharingUsageLimit'),
    imgExtraLarge: Type.optional.string(json.imgExtraLarge, 'ArticleAttributeView.imgExtraLarge'),
    imgExtraLargeHeight: Type.optional.number(json.imgExtraLargeHeight, 'ArticleAttributeView.imgExtraLargeHeight'),
    imgExtraLargeWidth: Type.optional.number(json.imgExtraLargeWidth, 'ArticleAttributeView.imgExtraLargeWidth'),
    imgLarge: Type.optional.string(json.imgLarge, 'ArticleAttributeView.imgLarge'),
    imgLargeHeight: Type.optional.number(json.imgLargeHeight, 'ArticleAttributeView.imgLargeHeight'),
    imgLargeWidth: Type.optional.number(json.imgLargeWidth, 'ArticleAttributeView.imgLargeWidth'),
    imgMedium: Type.optional.string(json.imgMedium, 'ArticleAttributeView.imgMedium'),
    imgMediumHeight: Type.optional.number(json.imgMediumHeight, 'ArticleAttributeView.imgMediumHeight'),
    imgMediumWidth: Type.optional.number(json.imgMediumWidth, 'ArticleAttributeView.imgMediumWidth'),
    imgSmall: Type.optional.string(json.imgSmall, 'ArticleAttributeView.imgSmall'),
    imgSmallHeight: Type.optional.number(json.imgSmallHeight, 'ArticleAttributeView.imgSmallHeight'),
    imgSmallWidth: Type.optional.number(json.imgSmallWidth, 'ArticleAttributeView.imgSmallWidth'),
    isbnWithSeparators: Type.optional.string(json.isbnWithSeparators, 'ArticleAttributeView.isbnWithSeparators'),
    libriDigitalNumber: Type.optional.string(json.libriDigitalNumber, 'ArticleAttributeView.libriDigitalNumber'),
    libriNumber: Type.optional.string(json.libriNumber, 'ArticleAttributeView.libriNumber'),
    mobipocketNumber: Type.optional.string(json.mobipocketNumber, 'ArticleAttributeView.mobipocketNumber'),
    orisNumber: Type.optional.string(json.orisNumber, 'ArticleAttributeView.orisNumber'),
    pages: Type.optional.string(json.pages, 'ArticleAttributeView.pages'),
    productLineId: Type.optional.number(json.productLineId, 'ArticleAttributeView.productLineId'),
    productLineName: Type.optional.string(json.productLineName, 'ArticleAttributeView.productLineName'),
    // Because our non-standard date format lets parsing fail for some cases in Safari browsers, we cut off the time
    // part of this string. A fix within the backend could have unknown side effects internally and externally. (MW)
    publicationDate: Type.optional.dateString(json.publicationDate && json.publicationDate.split(' ')[0], 'ArticleAttributeView.publicationDate'),
    publisherName: Type.optional.string(json.publisherName, 'ArticleAttributeView.publisherName'),
    serieNr: Type.optional.string(json.serieNr, 'ArticleAttributeView.serieNr'),
    serieSort: Type.optional.number(json.serieSort, 'ArticleAttributeView.serieSort'),
    serieText: Type.optional.string(json.serieText, 'ArticleAttributeView.serieText'),
    shortSubtitle: Type.optional.string(json.shortSubtitle, 'ArticleAttributeView.shortSubtitle'),
    subtitle: Type.optional.string(json.subtitle, 'ArticleAttributeView.subtitle'),
    title: Type.optional.string(json.title, 'ArticleAttributeView.title'),
    translatorList: Type.optional.string(json.translatorList, 'ArticleAttributeView.translatorList'),
    languageCode: Type.optional.string(json.languageCode, 'ArticleAttributeView.languageCode'),
});
const WsArticleAttributeView = { parse: parse$a };

const parse$9 = (json) => ({
    reviewId: Type.string(json.reviewId, 'Review.reviewId'),
    articleId: Type.number(json.articleId, 'Review.articleId'),
    clientId: Type.number(json.clientId, 'Review.clientId'),
    author: Type.string(json.author, 'Review.author'),
    title: Type.optional.string(json.title, 'Review.title'),
    text: Type.string(json.text, 'Review.text'),
    rating: Type.number(json.rating, 'Review.rating'),
    positiveVotings: Type.number(json.positiveVotings, 'Review.positiveVotings'),
    negativeVotings: Type.number(json.negativeVotings, 'Review.negativeVotings'),
    topReviewer: Type.boolean(json.topReviewer, 'Review.topReviewer'),
    oneOfTheFirst: Type.boolean(json.oneOfTheFirst, 'Review.oneOfTheFirst'),
    creationDate: Type.optional.dateString(json.creationDate, 'Review.creationDate'),
    articleTitle: Type.optional.string(json.articleTile, 'Review.articleTitle'),
    articleAuthors: Type.optional.string(json.articleAuthors, 'Review.articleAuthors'),
    coverImg: Type.optional.string(json.coverImg, 'Review.coverImg'),
    rejected: Type.boolean(json.rejected, 'Review.rejected'),
    released: Type.boolean(json.released, 'Review.released'),
    rejectReason: Type.optional.string(json.rejectReason, 'Review.rejectReason'),
    email: Type.optional.string(json.email, 'Review.email'),
    unmappableCharacters: Type.optional.string(json.unmappableCharacters, 'Review.unmappableCharacters'),
});
const WsReview = { parse: parse$9 };

const parse$8 = (json) => ({
    id: Type.number(json.id, 'DigitalArticleAttributes.id'),
    articleId: Type.number(json.articleId, 'DigitalArticleAttributes.articleId'),
    fileSize: Type.number(json.fileSize, 'DigitalArticleAttributes.fileSize'),
    downloadTypeId: Type.number(json.downloadTypeId, 'DigitalArticleAttributes.downloadTypeId'),
    creationTime: Type.dateString(json.creationTime, 'DigitalArticleAttributes.creationTime'),
    modificationTime: Type.optional.dateString(json.modificationTime, 'DigitalArticleAttributes.modificationTime'),
    libriDigitalId: Type.optional.string(json.libriDigitalId, 'DigitalArticleAttributes.libriDigitalId'),
    repository: Type.optional.string(json.repository, 'DigitalArticleAttributes.repository'),
    supplierId: Type.optional.number(json.supplierId, 'DigitalArticleAttributes.supplierId'),
    supplierIdType: Type.optional.string(json.supplierIdType, 'DigitalArticleAttributes.supplierIdType'),
    saleType: Type.optional.string(json.saleType, 'DigitalArticleAttributes.saleType'),
    dlzlRepo: Type.optional.string(json.dlzlRepo, 'DigitalArticleAttributes.dlzlRepo'),
    dlzlArtinr: Type.optional.string(json.dlzlArtinr, 'DigitalArticleAttributes.dlzlArtinr'),
    drmType: Type.string(json.drmType, 'DigitalArticleAttributes.drmType'),
    priority: Type.optional.number(json.priority, 'DigitalArticleAttributes.priority'),
    allowedCountries: Type.optional.string(json.allowedCountries, 'DigitalArticleAttributes.allowedCountries'),
    cdpPublicationId: Type.optional.string(json.cdpPublicationId, 'DigitalArticleAttributes.cdpPublicationId'),
    efreeFulltextAllowed: Type.optional.boolean(json.freeFulltextAllowed, 'DigitalArticleAttributes.efreeFulltextAllowed'),
});
const WsDigitalArticleAttributes = { parse: parse$8 };

const parse$7 = (json) => ({
    id: Type.number(json.id, 'Keyword.id'),
    abbr: Type.string(json.abbr, 'Keyword.abbr'),
    text: Type.optional.string(json.text, 'Keyword.text'),
    textUnified: Type.optional.string(json.textUnified, 'Keyword.textUnified'),
});
const WsKeyword = { parse: parse$7 };

const parse$6 = (json) => ({
    id: Type.number(json.id, 'Person.id'),
    displayable: Type.boolean(json.displayable, 'Person.displayable'),
    name: Type.string(json.name, 'Person.name'),
    normalizedName: Type.string(json.normalizedName, 'Person.normalizedName'),
});
const WsPerson = { parse: parse$6 };

const parse$5 = (json) => ({
    additionalImage: Type.optional.string(json.additionalImage, 'CombinedProduct.additionalImage'),
    additionalProductArticleId: Type.number(json.additionalProductArticleId, 'CombinedProduct.additionalProductArticleId'),
    additionalProductOriginalPrice: Type.optional.number(json.additionalProductOriginalPrice, 'CombinedProduct.additionalProductOriginalPrice'),
    additionalProductPrice: Type.number(json.additionalProductPrice, 'CombinedProduct.additionalProductPrice'),
    additionalProductTitle: Type.optional.string(json.additionalProductTitle, 'CombinedProduct.additionalProductTitle'),
    baseProductArticleId: Type.number(json.baseProductArticleId, 'CombinedProduct.baseProductArticleId'),
    baseProductTitle: Type.optional.string(json.baseProductTitle, 'CombinedProduct.baseProductTitle'),
    combinedPriceText: Type.string(json.combinedPriceText, 'CombinedProduct.combinedPriceText'),
    comparedPriceText: Type.string(json.comparedPriceText, 'CombinedProduct.comparedPriceText'),
    rebateCategory: Type.optional.number(json.rebateCategory, 'CombinedProduct.rebateCategory'),
    title: Type.string(json.title, 'CombinedProduct.title'),
});
const WsCombinedProduct = { parse: parse$5 };

const parse$4 = (json) => ({
    id: Type.number(json.id, 'CommodityGroup.id'),
    number: Type.number(json.number, 'CommodityGroup.number'),
    text: Type.optional.string(json.text, 'CommodityGroup.text'),
});
const WsCommodityGroup = { parse: parse$4 };

const parse$3 = (json) => ({
    id: Type.string(json.id, 'SubscriptionModel.id'),
    subscriptionModelId: Type.number(json.subscriptionModelId, 'SubscriptionModel.subscriptionModelId'),
    name: Type.string(json.name, 'SubscriptionModel.name'),
    articleId: Type.number(json.articleId, 'SubscriptionModel.articleId'),
    price: Type.number(json.price, 'SubscriptionModel.price'),
    checkoutInformation: Type.string(json.checkoutInformation, 'SubscriptionModel.checkoutInformation'),
    deductionPeriodMonths: Type.number(json.deductionPeriodMonths, 'SubscriptionModel.deductionPeriodMonths'),
    rebateDurationMonths: Type.number(json.rebateDurationMonths, 'SubscriptionModel.rebateDurationMonths'),
    naviNodeId: Type.optional.number(json.naviNodeId, 'SubscriptionModel.naviNodeId'),
    creationDate: Type.dateString(json.creationDate, 'SubscriptionModel.creationDate'),
});
const WsSubscriptionModel = { parse: parse$3 };

const _parseArticleAttributeView$1 = (articleAttributeView) => articleAttributeView
    ? WsArticleAttributeView.parse(Type.object(articleAttributeView, 'Article.articleAttributeView'))
    : undefined;
const _parseClientArticle = (clientArticle) => clientArticle ? WsClientArticle.parse(Type.object(clientArticle, 'Article.clientArticle')) : undefined;
const _parseCombinedProduct = (combinedProduct) => combinedProduct ? WsCombinedProduct.parse(Type.object(combinedProduct, 'Article.combinedProduct')) : undefined;
const _parseCommodityGroup = (commodityGroup) => commodityGroup ? WsCommodityGroup.parse(Type.object(commodityGroup, 'Article.commodityGroup')) : undefined;
const _parseProductType$1 = (productType) => productType ? WsArticleType.parse(Type.object(productType, 'Article.productType')) : undefined;
const _parseSubscriptionModel = (subscriptionModel) => subscriptionModel
    ? WsSubscriptionModel.parse(Type.object(subscriptionModel, 'Article.subscriptionModel'))
    : undefined;
const parse$2 = (json) => {
    var _a, _b, _c, _d, _e;
    return ({
        active: Type.boolean(json.active, 'Article.active'),
        alsoAvailableDummyArticleId: Type.optional.number(json.alsoAvailableDummyArticleId, 'Article.alsoAvailableDummyArticleId'),
        alsoAvailableInBundleId: Type.optional.number(json.alsoAvailableInBundleId, 'Article.alsoAvailableInBundleId'),
        alternativeArticles: (_a = Type.optional
            .array(json.alternativeArticles, 'Article.alternativeArticles')) === null || _a === void 0 ? void 0 : _a.map(WsAlternativeArticle.parse),
        articleAnnotations: (_b = Type.optional
            .array(json.articleAnnotations, 'Article.articleAnnotations')) === null || _b === void 0 ? void 0 : _b.map(WsAnnotation.parse),
        articleAttributeView: _parseArticleAttributeView$1(json.articleAttributeView),
        articlePrices: Type.array(json.articlePrices, 'Article.articlePrices').map(WsArticlePrice.parse),
        availableForOneClick: Type.boolean(json.availableForOneClick, 'Article.availableForOneClick'),
        binderTypeId: Type.number(json.binderTypeId, 'Article.binderTypeId'),
        bundleId: Type.optional.number(json.bundleId, 'Article.bundleId'),
        clientArticle: _parseClientArticle(json.clientArticle),
        combinedProduct: _parseCombinedProduct(json.combinedProduct),
        commodityGroup: _parseCommodityGroup(json.commodityGroup),
        deliveryBookspressBookshop: Type.boolean(json.deliveryBookspressBookshop, 'Article.deliveryBookspressBookshop'),
        deliveryDownload: Type.boolean(json.deliveryDownload, 'Article.deliveryDownload'),
        deliveryShipmentBookshop: Type.boolean(json.deliveryShipmentBookshop, 'Article.deliveryShipmentBookshop'),
        deliveryShipmentDirect: Type.boolean(json.deliveryShipmentDirect, 'Article.deliveryShipmentDirect'),
        digitalArticleAttributes: (_c = Type.optional
            .array(json.downloadAttributes, 'Article.digitalArticleAttributes')) === null || _c === void 0 ? void 0 : _c.map(WsDigitalArticleAttributes.parse),
        externalArticle: Type.boolean(json.externalArticle, 'Article.externalArticle'),
        externalButtonText: Type.optional.string(json.externalButtonText, 'Article.externalButtonText'),
        externalCssClassName: Type.optional.string(json.externalCssClassName, 'Article.externalCssClassName'),
        externalHintLayer: Type.optional.string(json.externalHintLayer, 'Article.externalHintLayer'),
        externalHintText: Type.optional.string(json.externalHintText, 'Article.externalHintText'),
        externalLogoUrl: Type.optional.string(json.externalLogoUrl, 'Article.externalLogoUrl'),
        externalMobileProductPageUrl: Type.optional.string(json.externalMobileProductPageUrl, 'Article.externalMobileProductPageUrl'),
        externalOpenNewWindow: Type.boolean(json.externalOpenNewWindow, 'Article.externalOpenNewWindow'),
        externalProductPageUrl: Type.optional.string(json.externalProductPageUrl, 'Article.externalProductPageUrl'),
        externalProviderName: Type.optional.string(json.externalProviderName, 'Article.externalProviderName'),
        externalShowHintLayer: Type.boolean(json.externalShowHintLayer, 'Article.externalShowHintLayer'),
        fixedPrice: Type.boolean(json.fixedPrice, 'Article.fixedPrice'),
        id: Type.number(json.id, 'Article.id'),
        keywords: (_d = Type.optional.array(json.keywords, 'Article.keywords')) === null || _d === void 0 ? void 0 : _d.map(WsKeyword.parse),
        lastAlternativeArticlesUpdate: Type.optional.dateString(json.lastAlternativeArticlesUpdate, 'Article.lastAlternativeArticlesUpdate'),
        modificationDate: Type.optional.dateString(json.modificationDate, 'Article.modificationDate'),
        noPickUpGood: Type.boolean(json.noPickUpGood, 'Article.noPickUpGood'),
        notAvailableAsAGift: Type.boolean(json.notAvailableAsAGift, 'Article.notAvailableAsAGift'),
        people: (_e = Type.optional.array(json.people, 'Article.people')) === null || _e === void 0 ? void 0 : _e.map(WsPerson.parse),
        productType: _parseProductType$1(json.productType),
        publisherId: Type.optional.number(json.publisherId, 'Article.publisherId'),
        rebateCategory: Type.optional.number(json.rebateCategory, 'Article.rebateCategory'),
        rebateDescription: Type.optional.string(json.rebateDescription, 'Article.rebateDescription'),
        restrictedToBundle: Type.boolean(json.restrictedToBundle, 'Article.restrictedToBundle'),
        reviewAvg: Type.falsyToUndefined.number(json.reviewAvg, 'Article.reviewAvg'),
        reviewVotes: Type.falsyToUndefined.number(json.reviewVotes, 'Article.reviewVotes'),
        reviews: Type.array(json.reviews, 'Article.reviews').map(WsReview.parse),
        searchableClientId: Type.number(json.searchableClientId, 'Article.searchableClientId'),
        spiegelProduct: Type.boolean(json.spiegelProduct, 'Article.spiegelProduct'),
        subscription: Type.boolean(json.subscription, 'Article.subscription'),
        subscriptionThatOffersArticle: _parseSubscriptionModel(json.subscriptionThatOffersArticle),
        availabilityData: WsAvailabilityData.parse(json.availabilityData),
    });
};
const parseList = (json) => Type.array(json.items, 'Article.items').map(parse$2);
const WsArticle = { parse: parse$2, parseList };

const parse$1 = (json) => ({
    authorList: Type.optional.string(json.authorList, 'SearchArticleAttributeView.authorList'),
    ean: Type.optional.string(json.ean, 'SearchArticleAttributeView.ean'),
    imgExtraLarge: Type.optional.string(json.imgExtraLarge, 'SearchArticleAttributeView.imgExtraLarge'),
    isbnWithSeparators: Type.optional.string(json.isbnWithSeparators, 'SearchArticleAttributeView.isbnWithSeparators'),
    languageCode: Type.optional.string(json.languageCode, 'SearchArticleAttributeView.languageCode'),
    // Because our non-standard date format lets parsing fail for some cases in Safari browsers, we cut off the time
    // part of this string. A fix within the backend could have unknown side effects internally and externally. (MW)
    publicationDate: Type.optional.string(json.publicationDate && json.publicationDate.split(' ')[0], 'SearchArticleAttributeView.publicationDate'),
    subtitle: Type.optional.string(json.subtitle, 'SearchArticleAttributeView.subtitle'),
    title: Type.optional.string(json.title, 'SearchArticleAttributeView.title'),
});
const WsSearchArticleAttributeView = { parse: parse$1 };

const _parseArticleAttributeView = (articleAttributeView) => articleAttributeView
    ? WsSearchArticleAttributeView.parse(Type.object(articleAttributeView, 'SearchArticle.articleAttributeView'))
    : undefined;
const _parseProductType = (productType) => productType ? WsArticleType.parse(Type.object(productType, 'SearchArticle.productType')) : undefined;
const parse = (json) => {
    var _a;
    return ({
        alternativeArticles: (_a = Type.optional
            .array(json.alternativeArticles, 'SearchArticle.alternativeArticles')) === null || _a === void 0 ? void 0 : _a.map(WsAlternativeArticle.parse),
        articleAttributeView: _parseArticleAttributeView(json.articleAttributeView),
        articlePrices: Type.array(json.articlePrices, 'SearchArticle.articlePrices').map(WsArticlePrice.parse),
        id: Type.number(json.id, 'SearchArticle.id'),
        productType: _parseProductType(json.productType),
        rebateCategory: Type.optional.number(json.rebateCategory, 'SearchArticle.rebateCategory'),
        availabilityData: WsAvailabilityData.parse(json.availabilityData),
        reviewAvg: Type.optional.number(json.reviewAvg, 'SearchArticle.reviewAvg'),
        reviewVotes: Type.optional.number(json.reviewVotes, 'SearchArticle.reviewVotes'),
    });
};
const WsSearchArticle = { parse };

addIntlData(intlData);

export { ARTICLE_TYPE_COUPON, AddToCartButton, AppTeaserEkidz, AppTeaserTolino, ArticleAuthors, ArticleAvailability, ArticleDeliveryDates, ArticleFilter, ArticleItem, ArticleSinglePrice, ArticleSort, ArticleTitle, ArticleToBasketLayer, ArticleTypeId, ArticleTypeView, BasketModals, CoverImg, DEFAULT_SORT_CRITERIA_CUSTOMER, DeliveryStatus, DigitalArticleCover, DigitalArticleDetails, DigitalArticleFilters, DigitalArticleList, DigitalArticleSearchFilter, DigitalArticleService, DigitalArticleView, DigitalArticles, DiscountBadge, DownloadActionButtons, DownloadActions, DownloadReaderButton, DownloadType, HelpTeaser, LanguageDisplay, PriceHint, ProductIconTools, QuickBuyButton, RecommendationCarousel, RecommendationCarouselItem, RecommendationProductDetails, RecommendationSlider, SearchArticleItem, SortCriteriaCustomer, SortCriteriaSearch, WsAlternativeArticle, WsAnnotation, WsAnnotationType, WsArticle, WsArticleAttributeBuilder, WsArticleAttributeView, WsArticleBuilder, WsArticlePrice, WsArticlePriceBuilder, WsArticleType, WsArticleTypeBuilder, WsClientArticle, WsCombinedProduct, WsCommodityGroup, WsDigitalArticle, WsDigitalArticleAttributes, WsDigitalArticleBuilder, WsKeyword, WsPerson, WsReview, WsSearchArticle, WsSubscriptionModel, WsWishlistItem, WsWishlistItemBuilder, getSortOption, parseSort, parseSortOption, useCurrentAscending, useCurrentSort, useCurrentSortOption };
